//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const BASE_URL = new InjectionToken<string>('BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class ApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:8080";
    }

    /**
     * @return OK
     */
    updateMessageStatus(id: number, body: UpdateMessageStatusDto): Observable<MessageDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/messages/{id}/status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMessageStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMessageStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto>;
        }));
    }

    protected processUpdateMessageStatus(response: HttpResponseBase): Observable<MessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateMessageQuestionType(id: number, body: UpdateMessageQuestionTypeDto): Observable<MessageDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/messages/{id}/question-type";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMessageQuestionType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMessageQuestionType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto>;
        }));
    }

    protected processUpdateMessageQuestionType(response: HttpResponseBase): Observable<MessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateMessagePerson(id: number, body: UpdateMessagePersonDto): Observable<MessageDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/messages/{id}/person";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMessagePerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMessagePerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto>;
        }));
    }

    protected processUpdateMessagePerson(response: HttpResponseBase): Observable<MessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateInternalMessageContext(id: number, body: UpdateContextMessageDto): Observable<MessageDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/messages/{id}/context";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInternalMessageContext(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInternalMessageContext(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto>;
        }));
    }

    protected processUpdateInternalMessageContext(response: HttpResponseBase): Observable<MessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateMessageCollaborator(id: number, body: UpdateMessageCollaboratorDto): Observable<MessageDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/messages/{id}/collaborator";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMessageCollaborator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMessageCollaborator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto>;
        }));
    }

    protected processUpdateMessageCollaborator(response: HttpResponseBase): Observable<MessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateMessageCase(id: number, body: UpdateMessageCaseDto): Observable<MessageDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/messages/{id}/case";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMessageCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMessageCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto>;
        }));
    }

    protected processUpdateMessageCase(response: HttpResponseBase): Observable<MessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateMessageBuilding(id: number, body: UpdateMessageBuildingDto): Observable<MessageDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/messages/{id}/building";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMessageBuilding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMessageBuilding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto>;
        }));
    }

    protected processUpdateMessageBuilding(response: HttpResponseBase): Observable<MessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    replyInternalMessage(id: number, body: ReplyMessageDto): Observable<MessageWithContextDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/messages/{id}/reply";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplyInternalMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplyInternalMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageWithContextDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageWithContextDto>;
        }));
    }

    protected processReplyInternalMessage(response: HttpResponseBase): Observable<MessageWithContextDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageWithContextDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    bulkUpdateInternalMessageContext(body: BulkUpdateMessageContextDto): Observable<void> {
        let url_ = this.baseUrl + "/api/backoffice/v1/messages/bulk-context";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpdateInternalMessageContext(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdateInternalMessageContext(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdateInternalMessageContext(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param message (optional) 
     * @param files (optional) 
     * @param icareUploads (optional) 
     * @return Created
     */
    createInternalMessageWithAttachments(message: CreateMessageDto | undefined, files: FileParameter[] | undefined, icareUploads: CreateIcareAttachmentUploadDto[] | undefined): Observable<MessageAttachmentSubmissionDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/messages-with-attachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (message === null || message === undefined)
            throw new Error("The parameter 'message' cannot be null.");
        else
            content_.append("message", JSON.stringify(message));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );
        if (icareUploads === null || icareUploads === undefined)
            throw new Error("The parameter 'icareUploads' cannot be null.");
        else
            icareUploads.forEach(item_ => content_.append("icareUploads", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInternalMessageWithAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInternalMessageWithAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageAttachmentSubmissionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageAttachmentSubmissionDto>;
        }));
    }

    protected processCreateInternalMessageWithAttachments(response: HttpResponseBase): Observable<MessageAttachmentSubmissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MessageAttachmentSubmissionDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    createInternalMessage(body: CreateMessageDto): Observable<MessageDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInternalMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInternalMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto>;
        }));
    }

    protected processCreateInternalMessage(response: HttpResponseBase): Observable<MessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    forwardAttachmentToIcare(id: number, body: ForwardAttachmentToIcareDto): Observable<AttachmentIcareForwardResultDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/attachments/{id}/icare-upload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForwardAttachmentToIcare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForwardAttachmentToIcare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentIcareForwardResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentIcareForwardResultDto>;
        }));
    }

    protected processForwardAttachmentToIcare(response: HttpResponseBase): Observable<AttachmentIcareForwardResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachmentIcareForwardResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    forwardAttachmentsToIcare(body: ForwardAttachmentsToIcareDto): Observable<AttachmentIcareForwardResultDto[]> {
        let url_ = this.baseUrl + "/api/backoffice/v1/attachments/icare-upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "*/*"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForwardAttachmentsToIcare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForwardAttachmentsToIcare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentIcareForwardResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentIcareForwardResultDto[]>;
        }));
    }

    protected processForwardAttachmentsToIcare(response: HttpResponseBase): Observable<AttachmentIcareForwardResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentIcareForwardResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param languageCode (optional) 
     * @return OK
     */
    getEstimationTownGroups(languageCode: string | undefined): Observable<MyEcabTownGroupDto[]> {
        let url_ = this.baseUrl + "/api/backoffice/v1/town-groups?";
        if (languageCode === null)
            throw new Error("The parameter 'languageCode' cannot be null.");
        else if (languageCode !== undefined)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstimationTownGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstimationTownGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyEcabTownGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyEcabTownGroupDto[]>;
        }));
    }

    protected processGetEstimationTownGroups(response: HttpResponseBase): Observable<MyEcabTownGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MyEcabTownGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getContactSubjects(): Observable<ContactSubjectDto[]> {
        let url_ = this.baseUrl + "/api/backoffice/v1/subjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactSubjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactSubjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactSubjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactSubjectDto[]>;
        }));
    }

    protected processGetContactSubjects(response: HttpResponseBase): Observable<ContactSubjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactSubjectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getStatusList(): Observable<StatusDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusDto>;
        }));
    }

    protected processGetStatusList(response: HttpResponseBase): Observable<StatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param q (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getPersons(q: string | undefined, page: number | undefined, size: number | undefined, sort: string[] | undefined): Observable<PageMyEcabPersonDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/persons?";
        if (q === null)
            throw new Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageMyEcabPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageMyEcabPersonDto>;
        }));
    }

    protected processGetPersons(response: HttpResponseBase): Observable<PageMyEcabPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageMyEcabPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filterId (optional) 
     * @param search (optional) 
     * @param buildingId (optional) 
     * @param buildingMode (optional) 
     * @param caseId (optional) 
     * @param townGroupId (optional) 
     * @param personId (optional) 
     * @param personMode (optional) 
     * @param caseType (optional) 
     * @param questionType (optional) 
     * @return OK
     */
    getInternalMessages(filterId: string | undefined, search: string | undefined, buildingId: string[] | undefined, buildingMode: BuildingMode | undefined, caseId: string | undefined, townGroupId: string[] | undefined, personId: string[] | undefined, personMode: PersonMode | undefined, caseType: CaseType | undefined, questionType: QuestionType | undefined, pageable: Pageable): Observable<PageMessageDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/messages?";
        if (filterId === null)
            throw new Error("The parameter 'filterId' cannot be null.");
        else if (filterId !== undefined)
            url_ += "filterId=" + encodeURIComponent("" + filterId) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (buildingId === null)
            throw new Error("The parameter 'buildingId' cannot be null.");
        else if (buildingId !== undefined)
            buildingId && buildingId.forEach(item => { url_ += "buildingId=" + encodeURIComponent("" + item) + "&"; });
        if (buildingMode === null)
            throw new Error("The parameter 'buildingMode' cannot be null.");
        else if (buildingMode !== undefined)
            url_ += "buildingMode=" + encodeURIComponent("" + buildingMode) + "&";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (townGroupId === null)
            throw new Error("The parameter 'townGroupId' cannot be null.");
        else if (townGroupId !== undefined)
            townGroupId && townGroupId.forEach(item => { url_ += "townGroupId=" + encodeURIComponent("" + item) + "&"; });
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            personId && personId.forEach(item => { url_ += "personId=" + encodeURIComponent("" + item) + "&"; });
        if (personMode === null)
            throw new Error("The parameter 'personMode' cannot be null.");
        else if (personMode !== undefined)
            url_ += "personMode=" + encodeURIComponent("" + personMode) + "&";
        if (caseType === null)
            throw new Error("The parameter 'caseType' cannot be null.");
        else if (caseType !== undefined)
            url_ += "caseType=" + encodeURIComponent("" + caseType) + "&";
        if (questionType === null)
            throw new Error("The parameter 'questionType' cannot be null.");
        else if (questionType !== undefined)
            url_ += "questionType=" + encodeURIComponent("" + questionType) + "&";
        if (pageable === undefined || pageable === null)
            throw new Error("The parameter 'pageable' must be defined and cannot be null.");
        else
            url_ += "pageable=" + encodeURIComponent("" + pageable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageMessageDto>;
        }));
    }

    protected processGetInternalMessages(response: HttpResponseBase): Observable<PageMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getInternalMessageById(id: number): Observable<MessageWithContextDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/messages/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalMessageById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalMessageById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageWithContextDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageWithContextDto>;
        }));
    }

    protected processGetInternalMessageById(response: HttpResponseBase): Observable<MessageWithContextDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageWithContextDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filterId (optional) 
     * @param search (optional) 
     * @param buildingId (optional) 
     * @param buildingMode (optional) 
     * @param caseId (optional) 
     * @param townGroupId (optional) 
     * @param personId (optional) 
     * @param personMode (optional) 
     * @param caseType (optional) 
     * @param questionType (optional) 
     * @return OK
     */
    getOpenMessagesGrouped(filterId: string | undefined, search: string | undefined, buildingId: string[] | undefined, buildingMode: BuildingMode2 | undefined, caseId: string | undefined, townGroupId: string[] | undefined, personId: string[] | undefined, personMode: PersonMode2 | undefined, caseType: CaseType2 | undefined, questionType: QuestionType2 | undefined): Observable<OpenMessagesGroupedDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/messages/open?";
        if (filterId === null)
            throw new Error("The parameter 'filterId' cannot be null.");
        else if (filterId !== undefined)
            url_ += "filterId=" + encodeURIComponent("" + filterId) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (buildingId === null)
            throw new Error("The parameter 'buildingId' cannot be null.");
        else if (buildingId !== undefined)
            buildingId && buildingId.forEach(item => { url_ += "buildingId=" + encodeURIComponent("" + item) + "&"; });
        if (buildingMode === null)
            throw new Error("The parameter 'buildingMode' cannot be null.");
        else if (buildingMode !== undefined)
            url_ += "buildingMode=" + encodeURIComponent("" + buildingMode) + "&";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (townGroupId === null)
            throw new Error("The parameter 'townGroupId' cannot be null.");
        else if (townGroupId !== undefined)
            townGroupId && townGroupId.forEach(item => { url_ += "townGroupId=" + encodeURIComponent("" + item) + "&"; });
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            personId && personId.forEach(item => { url_ += "personId=" + encodeURIComponent("" + item) + "&"; });
        if (personMode === null)
            throw new Error("The parameter 'personMode' cannot be null.");
        else if (personMode !== undefined)
            url_ += "personMode=" + encodeURIComponent("" + personMode) + "&";
        if (caseType === null)
            throw new Error("The parameter 'caseType' cannot be null.");
        else if (caseType !== undefined)
            url_ += "caseType=" + encodeURIComponent("" + caseType) + "&";
        if (questionType === null)
            throw new Error("The parameter 'questionType' cannot be null.");
        else if (questionType !== undefined)
            url_ += "questionType=" + encodeURIComponent("" + questionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpenMessagesGrouped(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpenMessagesGrouped(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpenMessagesGroupedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpenMessagesGroupedDto>;
        }));
    }

    protected processGetOpenMessagesGrouped(response: HttpResponseBase): Observable<OpenMessagesGroupedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OpenMessagesGroupedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPredefinedMessageFilters(): Observable<PredefinedMessageFilterDto[]> {
        let url_ = this.baseUrl + "/api/backoffice/v1/message-filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPredefinedMessageFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPredefinedMessageFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PredefinedMessageFilterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PredefinedMessageFilterDto[]>;
        }));
    }

    protected processGetPredefinedMessageFilters(response: HttpResponseBase): Observable<PredefinedMessageFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PredefinedMessageFilterDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param buildingId (optional) 
     * @param statusActive (optional) 
     * @param languageCode (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getIncidents(personId: number | undefined, buildingId: number | undefined, statusActive: boolean | undefined, languageCode: string | undefined, page: number | undefined, size: number | undefined, sort: string[] | undefined): Observable<PageMyEcabIncidentSummaryDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/incidents?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (buildingId === null)
            throw new Error("The parameter 'buildingId' cannot be null.");
        else if (buildingId !== undefined)
            url_ += "buildingId=" + encodeURIComponent("" + buildingId) + "&";
        if (statusActive === null)
            throw new Error("The parameter 'statusActive' cannot be null.");
        else if (statusActive !== undefined)
            url_ += "statusActive=" + encodeURIComponent("" + statusActive) + "&";
        if (languageCode === null)
            throw new Error("The parameter 'languageCode' cannot be null.");
        else if (languageCode !== undefined)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageMyEcabIncidentSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageMyEcabIncidentSummaryDto>;
        }));
    }

    protected processGetIncidents(response: HttpResponseBase): Observable<PageMyEcabIncidentSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageMyEcabIncidentSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDocumentTypes(): Observable<IcareDocumentTypeOptionDto[]> {
        let url_ = this.baseUrl + "/api/backoffice/v1/document-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IcareDocumentTypeOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IcareDocumentTypeOptionDto[]>;
        }));
    }

    protected processGetDocumentTypes(response: HttpResponseBase): Observable<IcareDocumentTypeOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IcareDocumentTypeOptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCollaborators(): Observable<CollaboratorDto[]> {
        let url_ = this.baseUrl + "/api/backoffice/v1/collaborators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCollaborators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCollaborators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollaboratorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollaboratorDto[]>;
        }));
    }

    protected processGetCollaborators(response: HttpResponseBase): Observable<CollaboratorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CollaboratorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param languageCode (optional) 
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getBuildings(personId: number | undefined, languageCode: string | undefined, page: number | undefined, size: number | undefined, sort: string[] | undefined): Observable<PageMyEcabBuildingSummaryDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/buildings?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (languageCode === null)
            throw new Error("The parameter 'languageCode' cannot be null.");
        else if (languageCode !== undefined)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuildings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuildings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageMyEcabBuildingSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageMyEcabBuildingSummaryDto>;
        }));
    }

    protected processGetBuildings(response: HttpResponseBase): Observable<PageMyEcabBuildingSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageMyEcabBuildingSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAttachmentsForMessage(messageId: number): Observable<AttachmentDto[]> {
        let url_ = this.baseUrl + "/api/backoffice/v1/attachments/{messageId}";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentsForMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentsForMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentDto[]>;
        }));
    }

    protected processGetAttachmentsForMessage(response: HttpResponseBase): Observable<AttachmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    downloadAttachment(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/backoffice/v1/attachments/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "*/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class UpdateMessageStatusDto implements IUpdateMessageStatusDto {
    status!: UpdateMessageStatusDtoStatus;

    [key: string]: any;

    constructor(data?: IUpdateMessageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateMessageStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMessageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IUpdateMessageStatusDto {
    status: UpdateMessageStatusDtoStatus;

    [key: string]: any;
}

export class MessageDto implements IMessageDto {
    id!: number;
    date!: Date;
    userId!: string;
    companyName!: string;
    lastname!: string;
    firstname!: string;
    email!: string;
    phone!: string;
    direction!: MessageDtoDirection;
    channel!: MessageDtoChannel;
    buildingSource!: string;
    buildingAddress!: string;
    personId!: string;
    buildingId!: string;
    townGroupId!: string;
    townGroupName!: string;
    townGroupType!: string;
    caseType!: MessageDtoCaseType;
    caseSource!: string;
    caseTitle!: string;
    caseId!: string;
    subject!: string;
    content!: string;
    status!: MessageDtoStatus;
    language!: string;
    assignedCollaboratorId!: string;
    assignedCollaboratorEmail!: string;
    questionType!: MessageDtoQuestionType;

    [key: string]: any;

    constructor(data?: IMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : <any>null;
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.direction = _data["direction"] !== undefined ? _data["direction"] : <any>null;
            this.channel = _data["channel"] !== undefined ? _data["channel"] : <any>null;
            this.buildingSource = _data["buildingSource"] !== undefined ? _data["buildingSource"] : <any>null;
            this.buildingAddress = _data["buildingAddress"] !== undefined ? _data["buildingAddress"] : <any>null;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
            this.buildingId = _data["buildingId"] !== undefined ? _data["buildingId"] : <any>null;
            this.townGroupId = _data["townGroupId"] !== undefined ? _data["townGroupId"] : <any>null;
            this.townGroupName = _data["townGroupName"] !== undefined ? _data["townGroupName"] : <any>null;
            this.townGroupType = _data["townGroupType"] !== undefined ? _data["townGroupType"] : <any>null;
            this.caseType = _data["caseType"] !== undefined ? _data["caseType"] : <any>null;
            this.caseSource = _data["caseSource"] !== undefined ? _data["caseSource"] : <any>null;
            this.caseTitle = _data["caseTitle"] !== undefined ? _data["caseTitle"] : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.assignedCollaboratorId = _data["assignedCollaboratorId"] !== undefined ? _data["assignedCollaboratorId"] : <any>null;
            this.assignedCollaboratorEmail = _data["assignedCollaboratorEmail"] !== undefined ? _data["assignedCollaboratorEmail"] : <any>null;
            this.questionType = _data["questionType"] !== undefined ? _data["questionType"] : <any>null;
        }
    }

    static fromJS(data: any): MessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["lastname"] = this.lastname !== undefined ? this.lastname : <any>null;
        data["firstname"] = this.firstname !== undefined ? this.firstname : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["direction"] = this.direction !== undefined ? this.direction : <any>null;
        data["channel"] = this.channel !== undefined ? this.channel : <any>null;
        data["buildingSource"] = this.buildingSource !== undefined ? this.buildingSource : <any>null;
        data["buildingAddress"] = this.buildingAddress !== undefined ? this.buildingAddress : <any>null;
        data["personId"] = this.personId !== undefined ? this.personId : <any>null;
        data["buildingId"] = this.buildingId !== undefined ? this.buildingId : <any>null;
        data["townGroupId"] = this.townGroupId !== undefined ? this.townGroupId : <any>null;
        data["townGroupName"] = this.townGroupName !== undefined ? this.townGroupName : <any>null;
        data["townGroupType"] = this.townGroupType !== undefined ? this.townGroupType : <any>null;
        data["caseType"] = this.caseType !== undefined ? this.caseType : <any>null;
        data["caseSource"] = this.caseSource !== undefined ? this.caseSource : <any>null;
        data["caseTitle"] = this.caseTitle !== undefined ? this.caseTitle : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["assignedCollaboratorId"] = this.assignedCollaboratorId !== undefined ? this.assignedCollaboratorId : <any>null;
        data["assignedCollaboratorEmail"] = this.assignedCollaboratorEmail !== undefined ? this.assignedCollaboratorEmail : <any>null;
        data["questionType"] = this.questionType !== undefined ? this.questionType : <any>null;
        return data;
    }
}

export interface IMessageDto {
    id: number;
    date: Date;
    userId: string;
    companyName: string;
    lastname: string;
    firstname: string;
    email: string;
    phone: string;
    direction: MessageDtoDirection;
    channel: MessageDtoChannel;
    buildingSource: string;
    buildingAddress: string;
    personId: string;
    buildingId: string;
    townGroupId: string;
    townGroupName: string;
    townGroupType: string;
    caseType: MessageDtoCaseType;
    caseSource: string;
    caseTitle: string;
    caseId: string;
    subject: string;
    content: string;
    status: MessageDtoStatus;
    language: string;
    assignedCollaboratorId: string;
    assignedCollaboratorEmail: string;
    questionType: MessageDtoQuestionType;

    [key: string]: any;
}

export class UpdateMessageQuestionTypeDto implements IUpdateMessageQuestionTypeDto {
    questionType!: UpdateMessageQuestionTypeDtoQuestionType;

    [key: string]: any;

    constructor(data?: IUpdateMessageQuestionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.questionType = _data["questionType"] !== undefined ? _data["questionType"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateMessageQuestionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMessageQuestionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["questionType"] = this.questionType !== undefined ? this.questionType : <any>null;
        return data;
    }
}

export interface IUpdateMessageQuestionTypeDto {
    questionType: UpdateMessageQuestionTypeDtoQuestionType;

    [key: string]: any;
}

export class UpdateMessagePersonDto implements IUpdateMessagePersonDto {
    personId!: string;
    companyName!: string;
    firstname!: string;
    lastname!: string;

    [key: string]: any;

    constructor(data?: IUpdateMessagePersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : <any>null;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateMessagePersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMessagePersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["personId"] = this.personId !== undefined ? this.personId : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["firstname"] = this.firstname !== undefined ? this.firstname : <any>null;
        data["lastname"] = this.lastname !== undefined ? this.lastname : <any>null;
        return data;
    }
}

export interface IUpdateMessagePersonDto {
    personId: string;
    companyName: string;
    firstname: string;
    lastname: string;

    [key: string]: any;
}

export class UpdateContextMessageDto implements IUpdateContextMessageDto {
    personId!: string;
    companyName!: string;
    firstname!: string;
    lastname!: string;
    buildingId!: string;
    buildingSource!: string;
    buildingAddress!: string;
    caseId!: string;
    caseSource!: string;
    caseType!: UpdateContextMessageDtoCaseType;
    caseTitle!: string;
    questionType!: UpdateContextMessageDtoQuestionType;
    subject!: string;

    [key: string]: any;

    constructor(data?: IUpdateContextMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : <any>null;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : <any>null;
            this.buildingId = _data["buildingId"] !== undefined ? _data["buildingId"] : <any>null;
            this.buildingSource = _data["buildingSource"] !== undefined ? _data["buildingSource"] : <any>null;
            this.buildingAddress = _data["buildingAddress"] !== undefined ? _data["buildingAddress"] : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.caseSource = _data["caseSource"] !== undefined ? _data["caseSource"] : <any>null;
            this.caseType = _data["caseType"] !== undefined ? _data["caseType"] : <any>null;
            this.caseTitle = _data["caseTitle"] !== undefined ? _data["caseTitle"] : <any>null;
            this.questionType = _data["questionType"] !== undefined ? _data["questionType"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateContextMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContextMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["personId"] = this.personId !== undefined ? this.personId : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["firstname"] = this.firstname !== undefined ? this.firstname : <any>null;
        data["lastname"] = this.lastname !== undefined ? this.lastname : <any>null;
        data["buildingId"] = this.buildingId !== undefined ? this.buildingId : <any>null;
        data["buildingSource"] = this.buildingSource !== undefined ? this.buildingSource : <any>null;
        data["buildingAddress"] = this.buildingAddress !== undefined ? this.buildingAddress : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["caseSource"] = this.caseSource !== undefined ? this.caseSource : <any>null;
        data["caseType"] = this.caseType !== undefined ? this.caseType : <any>null;
        data["caseTitle"] = this.caseTitle !== undefined ? this.caseTitle : <any>null;
        data["questionType"] = this.questionType !== undefined ? this.questionType : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        return data;
    }
}

export interface IUpdateContextMessageDto {
    personId: string;
    companyName: string;
    firstname: string;
    lastname: string;
    buildingId: string;
    buildingSource: string;
    buildingAddress: string;
    caseId: string;
    caseSource: string;
    caseType: UpdateContextMessageDtoCaseType;
    caseTitle: string;
    questionType: UpdateContextMessageDtoQuestionType;
    subject: string;

    [key: string]: any;
}

export class UpdateMessageCollaboratorDto implements IUpdateMessageCollaboratorDto {
    assignedCollaboratorId!: string;
    assignedCollaboratorEmail!: string;

    [key: string]: any;

    constructor(data?: IUpdateMessageCollaboratorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.assignedCollaboratorId = _data["assignedCollaboratorId"] !== undefined ? _data["assignedCollaboratorId"] : <any>null;
            this.assignedCollaboratorEmail = _data["assignedCollaboratorEmail"] !== undefined ? _data["assignedCollaboratorEmail"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateMessageCollaboratorDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMessageCollaboratorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["assignedCollaboratorId"] = this.assignedCollaboratorId !== undefined ? this.assignedCollaboratorId : <any>null;
        data["assignedCollaboratorEmail"] = this.assignedCollaboratorEmail !== undefined ? this.assignedCollaboratorEmail : <any>null;
        return data;
    }
}

export interface IUpdateMessageCollaboratorDto {
    assignedCollaboratorId: string;
    assignedCollaboratorEmail: string;

    [key: string]: any;
}

export class UpdateMessageCaseDto implements IUpdateMessageCaseDto {
    caseId!: string;
    caseType!: UpdateMessageCaseDtoCaseType;
    caseSource!: string;
    caseTitle!: string;

    [key: string]: any;

    constructor(data?: IUpdateMessageCaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.caseType = _data["caseType"] !== undefined ? _data["caseType"] : <any>null;
            this.caseSource = _data["caseSource"] !== undefined ? _data["caseSource"] : <any>null;
            this.caseTitle = _data["caseTitle"] !== undefined ? _data["caseTitle"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateMessageCaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMessageCaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["caseType"] = this.caseType !== undefined ? this.caseType : <any>null;
        data["caseSource"] = this.caseSource !== undefined ? this.caseSource : <any>null;
        data["caseTitle"] = this.caseTitle !== undefined ? this.caseTitle : <any>null;
        return data;
    }
}

export interface IUpdateMessageCaseDto {
    caseId: string;
    caseType: UpdateMessageCaseDtoCaseType;
    caseSource: string;
    caseTitle: string;

    [key: string]: any;
}

export class UpdateMessageBuildingDto implements IUpdateMessageBuildingDto {
    buildingId!: string;
    buildingSource!: string;
    buildingAddress!: string;

    [key: string]: any;

    constructor(data?: IUpdateMessageBuildingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buildingId = _data["buildingId"] !== undefined ? _data["buildingId"] : <any>null;
            this.buildingSource = _data["buildingSource"] !== undefined ? _data["buildingSource"] : <any>null;
            this.buildingAddress = _data["buildingAddress"] !== undefined ? _data["buildingAddress"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateMessageBuildingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMessageBuildingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buildingId"] = this.buildingId !== undefined ? this.buildingId : <any>null;
        data["buildingSource"] = this.buildingSource !== undefined ? this.buildingSource : <any>null;
        data["buildingAddress"] = this.buildingAddress !== undefined ? this.buildingAddress : <any>null;
        return data;
    }
}

export interface IUpdateMessageBuildingDto {
    buildingId: string;
    buildingSource: string;
    buildingAddress: string;

    [key: string]: any;
}

export class ReplyMessageDto implements IReplyMessageDto {
    direction!: ReplyMessageDtoDirection;
    channel!: ReplyMessageDtoChannel;
    content!: string;
    language!: string;

    [key: string]: any;

    constructor(data?: IReplyMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.direction = _data["direction"] !== undefined ? _data["direction"] : <any>null;
            this.channel = _data["channel"] !== undefined ? _data["channel"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): ReplyMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReplyMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["direction"] = this.direction !== undefined ? this.direction : <any>null;
        data["channel"] = this.channel !== undefined ? this.channel : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        return data;
    }
}

export interface IReplyMessageDto {
    direction: ReplyMessageDtoDirection;
    channel: ReplyMessageDtoChannel;
    content: string;
    language: string;

    [key: string]: any;
}

export class AttachmentDto implements IAttachmentDto {
    id!: number;
    kind!: AttachmentDtoKind;
    storageId!: string;
    linkUrl!: string;
    icareDocumentId!: string;
    filename!: string;
    contentType!: string;
    size!: number;
    metadata!: string;
    icareDocumentUrl!: string;

    [key: string]: any;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.kind = _data["kind"] !== undefined ? _data["kind"] : <any>null;
            this.storageId = _data["storageId"] !== undefined ? _data["storageId"] : <any>null;
            this.linkUrl = _data["linkUrl"] !== undefined ? _data["linkUrl"] : <any>null;
            this.icareDocumentId = _data["icareDocumentId"] !== undefined ? _data["icareDocumentId"] : <any>null;
            this.filename = _data["filename"] !== undefined ? _data["filename"] : <any>null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
            this.size = _data["size"] !== undefined ? _data["size"] : <any>null;
            this.metadata = _data["metadata"] !== undefined ? _data["metadata"] : <any>null;
            this.icareDocumentUrl = _data["icareDocumentUrl"] !== undefined ? _data["icareDocumentUrl"] : <any>null;
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["kind"] = this.kind !== undefined ? this.kind : <any>null;
        data["storageId"] = this.storageId !== undefined ? this.storageId : <any>null;
        data["linkUrl"] = this.linkUrl !== undefined ? this.linkUrl : <any>null;
        data["icareDocumentId"] = this.icareDocumentId !== undefined ? this.icareDocumentId : <any>null;
        data["filename"] = this.filename !== undefined ? this.filename : <any>null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        data["size"] = this.size !== undefined ? this.size : <any>null;
        data["metadata"] = this.metadata !== undefined ? this.metadata : <any>null;
        data["icareDocumentUrl"] = this.icareDocumentUrl !== undefined ? this.icareDocumentUrl : <any>null;
        return data;
    }
}

export interface IAttachmentDto {
    id: number;
    kind: AttachmentDtoKind;
    storageId: string;
    linkUrl: string;
    icareDocumentId: string;
    filename: string;
    contentType: string;
    size: number;
    metadata: string;
    icareDocumentUrl: string;

    [key: string]: any;
}

export class MessageWithAttachmentsDto implements IMessageWithAttachmentsDto {
    id!: number;
    date!: Date;
    userId!: string;
    companyName!: string;
    lastname!: string;
    firstname!: string;
    email!: string;
    phone!: string;
    direction!: MessageWithAttachmentsDtoDirection;
    channel!: MessageWithAttachmentsDtoChannel;
    buildingSource!: string;
    buildingAddress!: string;
    personId!: string;
    buildingId!: string;
    townGroupId!: string;
    townGroupName!: string;
    townGroupType!: string;
    caseType!: MessageWithAttachmentsDtoCaseType;
    caseSource!: string;
    caseTitle!: string;
    caseId!: string;
    subject!: string;
    content!: string;
    status!: MessageWithAttachmentsDtoStatus;
    assignedCollaboratorId!: string;
    assignedCollaboratorEmail!: string;
    questionType!: MessageWithAttachmentsDtoQuestionType;
    attachments!: AttachmentDto[];

    [key: string]: any;

    constructor(data?: IMessageWithAttachmentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.attachments) {
                this.attachments = [];
                for (let i = 0; i < data.attachments.length; i++) {
                    let item = data.attachments[i];
                    this.attachments[i] = item && !(<any>item).toJSON ? new AttachmentDto(item) : <AttachmentDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : <any>null;
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.direction = _data["direction"] !== undefined ? _data["direction"] : <any>null;
            this.channel = _data["channel"] !== undefined ? _data["channel"] : <any>null;
            this.buildingSource = _data["buildingSource"] !== undefined ? _data["buildingSource"] : <any>null;
            this.buildingAddress = _data["buildingAddress"] !== undefined ? _data["buildingAddress"] : <any>null;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
            this.buildingId = _data["buildingId"] !== undefined ? _data["buildingId"] : <any>null;
            this.townGroupId = _data["townGroupId"] !== undefined ? _data["townGroupId"] : <any>null;
            this.townGroupName = _data["townGroupName"] !== undefined ? _data["townGroupName"] : <any>null;
            this.townGroupType = _data["townGroupType"] !== undefined ? _data["townGroupType"] : <any>null;
            this.caseType = _data["caseType"] !== undefined ? _data["caseType"] : <any>null;
            this.caseSource = _data["caseSource"] !== undefined ? _data["caseSource"] : <any>null;
            this.caseTitle = _data["caseTitle"] !== undefined ? _data["caseTitle"] : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.assignedCollaboratorId = _data["assignedCollaboratorId"] !== undefined ? _data["assignedCollaboratorId"] : <any>null;
            this.assignedCollaboratorEmail = _data["assignedCollaboratorEmail"] !== undefined ? _data["assignedCollaboratorEmail"] : <any>null;
            this.questionType = _data["questionType"] !== undefined ? _data["questionType"] : <any>null;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDto.fromJS(item));
            }
            else {
                this.attachments = <any>null;
            }
        }
    }

    static fromJS(data: any): MessageWithAttachmentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageWithAttachmentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["lastname"] = this.lastname !== undefined ? this.lastname : <any>null;
        data["firstname"] = this.firstname !== undefined ? this.firstname : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["direction"] = this.direction !== undefined ? this.direction : <any>null;
        data["channel"] = this.channel !== undefined ? this.channel : <any>null;
        data["buildingSource"] = this.buildingSource !== undefined ? this.buildingSource : <any>null;
        data["buildingAddress"] = this.buildingAddress !== undefined ? this.buildingAddress : <any>null;
        data["personId"] = this.personId !== undefined ? this.personId : <any>null;
        data["buildingId"] = this.buildingId !== undefined ? this.buildingId : <any>null;
        data["townGroupId"] = this.townGroupId !== undefined ? this.townGroupId : <any>null;
        data["townGroupName"] = this.townGroupName !== undefined ? this.townGroupName : <any>null;
        data["townGroupType"] = this.townGroupType !== undefined ? this.townGroupType : <any>null;
        data["caseType"] = this.caseType !== undefined ? this.caseType : <any>null;
        data["caseSource"] = this.caseSource !== undefined ? this.caseSource : <any>null;
        data["caseTitle"] = this.caseTitle !== undefined ? this.caseTitle : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["assignedCollaboratorId"] = this.assignedCollaboratorId !== undefined ? this.assignedCollaboratorId : <any>null;
        data["assignedCollaboratorEmail"] = this.assignedCollaboratorEmail !== undefined ? this.assignedCollaboratorEmail : <any>null;
        data["questionType"] = this.questionType !== undefined ? this.questionType : <any>null;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IMessageWithAttachmentsDto {
    id: number;
    date: Date;
    userId: string;
    companyName: string;
    lastname: string;
    firstname: string;
    email: string;
    phone: string;
    direction: MessageWithAttachmentsDtoDirection;
    channel: MessageWithAttachmentsDtoChannel;
    buildingSource: string;
    buildingAddress: string;
    personId: string;
    buildingId: string;
    townGroupId: string;
    townGroupName: string;
    townGroupType: string;
    caseType: MessageWithAttachmentsDtoCaseType;
    caseSource: string;
    caseTitle: string;
    caseId: string;
    subject: string;
    content: string;
    status: MessageWithAttachmentsDtoStatus;
    assignedCollaboratorId: string;
    assignedCollaboratorEmail: string;
    questionType: MessageWithAttachmentsDtoQuestionType;
    attachments: IAttachmentDto[];

    [key: string]: any;
}

export class MessageWithContextDto implements IMessageWithContextDto {
    message!: MessageWithAttachmentsDto;
    sameContextMessages!: MessageWithAttachmentsDto[];

    [key: string]: any;

    constructor(data?: IMessageWithContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.message = data.message && !(<any>data.message).toJSON ? new MessageWithAttachmentsDto(data.message) : <MessageWithAttachmentsDto>this.message;
            if (data.sameContextMessages) {
                this.sameContextMessages = [];
                for (let i = 0; i < data.sameContextMessages.length; i++) {
                    let item = data.sameContextMessages[i];
                    this.sameContextMessages[i] = item && !(<any>item).toJSON ? new MessageWithAttachmentsDto(item) : <MessageWithAttachmentsDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"] ? MessageWithAttachmentsDto.fromJS(_data["message"]) : <any>null;
            if (Array.isArray(_data["sameContextMessages"])) {
                this.sameContextMessages = [] as any;
                for (let item of _data["sameContextMessages"])
                    this.sameContextMessages!.push(MessageWithAttachmentsDto.fromJS(item));
            }
            else {
                this.sameContextMessages = <any>null;
            }
        }
    }

    static fromJS(data: any): MessageWithContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageWithContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message ? this.message.toJSON() : <any>null;
        if (Array.isArray(this.sameContextMessages)) {
            data["sameContextMessages"] = [];
            for (let item of this.sameContextMessages)
                data["sameContextMessages"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IMessageWithContextDto {
    message: IMessageWithAttachmentsDto;
    sameContextMessages: IMessageWithAttachmentsDto[];

    [key: string]: any;
}

export class BulkUpdateMessageContextDto implements IBulkUpdateMessageContextDto {
    messageIds!: number[];
    personId!: string;
    companyName!: string;
    firstname!: string;
    lastname!: string;
    buildingId!: string;
    buildingSource!: string;
    buildingAddress!: string;
    caseId!: string;
    caseSource!: string;
    caseType!: BulkUpdateMessageContextDtoCaseType;
    caseTitle!: string;
    questionType!: BulkUpdateMessageContextDtoQuestionType;
    subject!: string;

    [key: string]: any;

    constructor(data?: IBulkUpdateMessageContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["messageIds"])) {
                this.messageIds = [] as any;
                for (let item of _data["messageIds"])
                    this.messageIds!.push(item);
            }
            else {
                this.messageIds = <any>null;
            }
            this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : <any>null;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : <any>null;
            this.buildingId = _data["buildingId"] !== undefined ? _data["buildingId"] : <any>null;
            this.buildingSource = _data["buildingSource"] !== undefined ? _data["buildingSource"] : <any>null;
            this.buildingAddress = _data["buildingAddress"] !== undefined ? _data["buildingAddress"] : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.caseSource = _data["caseSource"] !== undefined ? _data["caseSource"] : <any>null;
            this.caseType = _data["caseType"] !== undefined ? _data["caseType"] : <any>null;
            this.caseTitle = _data["caseTitle"] !== undefined ? _data["caseTitle"] : <any>null;
            this.questionType = _data["questionType"] !== undefined ? _data["questionType"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
        }
    }

    static fromJS(data: any): BulkUpdateMessageContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateMessageContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.messageIds)) {
            data["messageIds"] = [];
            for (let item of this.messageIds)
                data["messageIds"].push(item);
        }
        data["personId"] = this.personId !== undefined ? this.personId : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["firstname"] = this.firstname !== undefined ? this.firstname : <any>null;
        data["lastname"] = this.lastname !== undefined ? this.lastname : <any>null;
        data["buildingId"] = this.buildingId !== undefined ? this.buildingId : <any>null;
        data["buildingSource"] = this.buildingSource !== undefined ? this.buildingSource : <any>null;
        data["buildingAddress"] = this.buildingAddress !== undefined ? this.buildingAddress : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["caseSource"] = this.caseSource !== undefined ? this.caseSource : <any>null;
        data["caseType"] = this.caseType !== undefined ? this.caseType : <any>null;
        data["caseTitle"] = this.caseTitle !== undefined ? this.caseTitle : <any>null;
        data["questionType"] = this.questionType !== undefined ? this.questionType : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        return data;
    }
}

export interface IBulkUpdateMessageContextDto {
    messageIds: number[];
    personId: string;
    companyName: string;
    firstname: string;
    lastname: string;
    buildingId: string;
    buildingSource: string;
    buildingAddress: string;
    caseId: string;
    caseSource: string;
    caseType: BulkUpdateMessageContextDtoCaseType;
    caseTitle: string;
    questionType: BulkUpdateMessageContextDtoQuestionType;
    subject: string;

    [key: string]: any;
}

export class CreateMessageDto implements ICreateMessageDto {
    personId!: string;
    companyName!: string;
    lastname!: string;
    firstname!: string;
    email!: string;
    phone!: string;
    direction!: CreateMessageDtoDirection;
    channel!: CreateMessageDtoChannel;
    buildingSource!: string;
    buildingAddress!: string;
    buildingId!: string;
    caseType!: CreateMessageDtoCaseType;
    caseSource!: string;
    caseTitle!: string;
    caseId!: string;
    subject!: string;
    content!: string;
    language!: string;
    questionType!: CreateMessageDtoQuestionType;

    [key: string]: any;

    constructor(data?: ICreateMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : <any>null;
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.direction = _data["direction"] !== undefined ? _data["direction"] : <any>null;
            this.channel = _data["channel"] !== undefined ? _data["channel"] : <any>null;
            this.buildingSource = _data["buildingSource"] !== undefined ? _data["buildingSource"] : <any>null;
            this.buildingAddress = _data["buildingAddress"] !== undefined ? _data["buildingAddress"] : <any>null;
            this.buildingId = _data["buildingId"] !== undefined ? _data["buildingId"] : <any>null;
            this.caseType = _data["caseType"] !== undefined ? _data["caseType"] : <any>null;
            this.caseSource = _data["caseSource"] !== undefined ? _data["caseSource"] : <any>null;
            this.caseTitle = _data["caseTitle"] !== undefined ? _data["caseTitle"] : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.questionType = _data["questionType"] !== undefined ? _data["questionType"] : <any>null;
        }
    }

    static fromJS(data: any): CreateMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["personId"] = this.personId !== undefined ? this.personId : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["lastname"] = this.lastname !== undefined ? this.lastname : <any>null;
        data["firstname"] = this.firstname !== undefined ? this.firstname : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["direction"] = this.direction !== undefined ? this.direction : <any>null;
        data["channel"] = this.channel !== undefined ? this.channel : <any>null;
        data["buildingSource"] = this.buildingSource !== undefined ? this.buildingSource : <any>null;
        data["buildingAddress"] = this.buildingAddress !== undefined ? this.buildingAddress : <any>null;
        data["buildingId"] = this.buildingId !== undefined ? this.buildingId : <any>null;
        data["caseType"] = this.caseType !== undefined ? this.caseType : <any>null;
        data["caseSource"] = this.caseSource !== undefined ? this.caseSource : <any>null;
        data["caseTitle"] = this.caseTitle !== undefined ? this.caseTitle : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["questionType"] = this.questionType !== undefined ? this.questionType : <any>null;
        return data;
    }
}

export interface ICreateMessageDto {
    personId: string;
    companyName: string;
    lastname: string;
    firstname: string;
    email: string;
    phone: string;
    direction: CreateMessageDtoDirection;
    channel: CreateMessageDtoChannel;
    buildingSource: string;
    buildingAddress: string;
    buildingId: string;
    caseType: CreateMessageDtoCaseType;
    caseSource: string;
    caseTitle: string;
    caseId: string;
    subject: string;
    content: string;
    language: string;
    questionType: CreateMessageDtoQuestionType;

    [key: string]: any;
}

export class CreateIcareAttachmentUploadDto implements ICreateIcareAttachmentUploadDto {
    fileIndex!: number;
    documentType!: string;

    [key: string]: any;

    constructor(data?: ICreateIcareAttachmentUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fileIndex = _data["fileIndex"] !== undefined ? _data["fileIndex"] : <any>null;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
        }
    }

    static fromJS(data: any): CreateIcareAttachmentUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIcareAttachmentUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fileIndex"] = this.fileIndex !== undefined ? this.fileIndex : <any>null;
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        return data;
    }
}

export interface ICreateIcareAttachmentUploadDto {
    fileIndex: number;
    documentType: string;

    [key: string]: any;
}

export class IcareAttachmentUploadResultDto implements IIcareAttachmentUploadResultDto {
    fileIndex!: number;
    filename!: string;
    documentType!: string;
    success!: boolean;
    errorMessage!: string;
    documentId!: string;

    [key: string]: any;

    constructor(data?: IIcareAttachmentUploadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fileIndex = _data["fileIndex"] !== undefined ? _data["fileIndex"] : <any>null;
            this.filename = _data["filename"] !== undefined ? _data["filename"] : <any>null;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : <any>null;
            this.documentId = _data["documentId"] !== undefined ? _data["documentId"] : <any>null;
        }
    }

    static fromJS(data: any): IcareAttachmentUploadResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcareAttachmentUploadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fileIndex"] = this.fileIndex !== undefined ? this.fileIndex : <any>null;
        data["filename"] = this.filename !== undefined ? this.filename : <any>null;
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        data["documentId"] = this.documentId !== undefined ? this.documentId : <any>null;
        return data;
    }
}

export interface IIcareAttachmentUploadResultDto {
    fileIndex: number;
    filename: string;
    documentType: string;
    success: boolean;
    errorMessage: string;
    documentId: string;

    [key: string]: any;
}

export class MessageAttachmentSubmissionDto implements IMessageAttachmentSubmissionDto {
    message!: MessageDto;
    icareUploads!: IcareAttachmentUploadResultDto[];

    [key: string]: any;

    constructor(data?: IMessageAttachmentSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.message = data.message && !(<any>data.message).toJSON ? new MessageDto(data.message) : <MessageDto>this.message;
            if (data.icareUploads) {
                this.icareUploads = [];
                for (let i = 0; i < data.icareUploads.length; i++) {
                    let item = data.icareUploads[i];
                    this.icareUploads[i] = item && !(<any>item).toJSON ? new IcareAttachmentUploadResultDto(item) : <IcareAttachmentUploadResultDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"] ? MessageDto.fromJS(_data["message"]) : <any>null;
            if (Array.isArray(_data["icareUploads"])) {
                this.icareUploads = [] as any;
                for (let item of _data["icareUploads"])
                    this.icareUploads!.push(IcareAttachmentUploadResultDto.fromJS(item));
            }
            else {
                this.icareUploads = <any>null;
            }
        }
    }

    static fromJS(data: any): MessageAttachmentSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageAttachmentSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message ? this.message.toJSON() : <any>null;
        if (Array.isArray(this.icareUploads)) {
            data["icareUploads"] = [];
            for (let item of this.icareUploads)
                data["icareUploads"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IMessageAttachmentSubmissionDto {
    message: IMessageDto;
    icareUploads: IIcareAttachmentUploadResultDto[];

    [key: string]: any;
}

export class ForwardAttachmentToIcareDto implements IForwardAttachmentToIcareDto {
    documentType!: string;
    comment!: string;

    [key: string]: any;

    constructor(data?: IForwardAttachmentToIcareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): ForwardAttachmentToIcareDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForwardAttachmentToIcareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }
}

export interface IForwardAttachmentToIcareDto {
    documentType: string;
    comment: string;

    [key: string]: any;
}

export class AttachmentIcareForwardResultDto implements IAttachmentIcareForwardResultDto {
    attachmentId!: number;
    filename!: string;
    documentType!: string;
    success!: boolean;
    errorMessage!: string;
    documentId!: string;
    icareDocumentUrl!: string;

    [key: string]: any;

    constructor(data?: IAttachmentIcareForwardResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.attachmentId = _data["attachmentId"] !== undefined ? _data["attachmentId"] : <any>null;
            this.filename = _data["filename"] !== undefined ? _data["filename"] : <any>null;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : <any>null;
            this.documentId = _data["documentId"] !== undefined ? _data["documentId"] : <any>null;
            this.icareDocumentUrl = _data["icareDocumentUrl"] !== undefined ? _data["icareDocumentUrl"] : <any>null;
        }
    }

    static fromJS(data: any): AttachmentIcareForwardResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentIcareForwardResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["attachmentId"] = this.attachmentId !== undefined ? this.attachmentId : <any>null;
        data["filename"] = this.filename !== undefined ? this.filename : <any>null;
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        data["documentId"] = this.documentId !== undefined ? this.documentId : <any>null;
        data["icareDocumentUrl"] = this.icareDocumentUrl !== undefined ? this.icareDocumentUrl : <any>null;
        return data;
    }
}

export interface IAttachmentIcareForwardResultDto {
    attachmentId: number;
    filename: string;
    documentType: string;
    success: boolean;
    errorMessage: string;
    documentId: string;
    icareDocumentUrl: string;

    [key: string]: any;
}

export class ForwardAttachmentsToIcareDto implements IForwardAttachmentsToIcareDto {
    attachments!: ForwardSelectedAttachmentToIcareDto[];

    [key: string]: any;

    constructor(data?: IForwardAttachmentsToIcareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.attachments) {
                this.attachments = [];
                for (let i = 0; i < data.attachments.length; i++) {
                    let item = data.attachments[i];
                    this.attachments[i] = item && !(<any>item).toJSON ? new ForwardSelectedAttachmentToIcareDto(item) : <ForwardSelectedAttachmentToIcareDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(ForwardSelectedAttachmentToIcareDto.fromJS(item));
            }
            else {
                this.attachments = <any>null;
            }
        }
    }

    static fromJS(data: any): ForwardAttachmentsToIcareDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForwardAttachmentsToIcareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IForwardAttachmentsToIcareDto {
    attachments: IForwardSelectedAttachmentToIcareDto[];

    [key: string]: any;
}

export class ForwardSelectedAttachmentToIcareDto implements IForwardSelectedAttachmentToIcareDto {
    attachmentId!: number;
    documentType!: string;
    comment!: string;

    [key: string]: any;

    constructor(data?: IForwardSelectedAttachmentToIcareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.attachmentId = _data["attachmentId"] !== undefined ? _data["attachmentId"] : <any>null;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): ForwardSelectedAttachmentToIcareDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForwardSelectedAttachmentToIcareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["attachmentId"] = this.attachmentId !== undefined ? this.attachmentId : <any>null;
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }
}

export interface IForwardSelectedAttachmentToIcareDto {
    attachmentId: number;
    documentType: string;
    comment: string;

    [key: string]: any;
}

export class MyEcabTownGroupDto implements IMyEcabTownGroupDto {
    id!: number | null;
    name!: string | null;
    type!: MyEcabTownGroupDtoType | null;

    [key: string]: any;

    constructor(data?: IMyEcabTownGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): MyEcabTownGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyEcabTownGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IMyEcabTownGroupDto {
    id: number | null;
    name: string | null;
    type: MyEcabTownGroupDtoType | null;

    [key: string]: any;
}

export class ContactSubjectDto implements IContactSubjectDto {
    key!: string;
    name!: string;

    [key: string]: any;

    constructor(data?: IContactSubjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ContactSubjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactSubjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IContactSubjectDto {
    key: string;
    name: string;

    [key: string]: any;
}

export class StatusDto implements IStatusDto {
    statusList!: StatusList[];

    [key: string]: any;

    constructor(data?: IStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["statusList"])) {
                this.statusList = [] as any;
                for (let item of _data["statusList"])
                    this.statusList!.push(item);
            }
            else {
                this.statusList = <any>null;
            }
        }
    }

    static fromJS(data: any): StatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.statusList)) {
            data["statusList"] = [];
            for (let item of this.statusList)
                data["statusList"].push(item);
        }
        return data;
    }
}

export interface IStatusDto {
    statusList: StatusList[];

    [key: string]: any;
}

export class MyEcabAddressDto implements IMyEcabAddressDto {
    id!: number | null;
    streetNumber!: string | null;
    streetNumberSuffix!: string | null;
    street!: MyEcabStreetDto;

    [key: string]: any;

    constructor(data?: IMyEcabAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.street = data.street && !(<any>data.street).toJSON ? new MyEcabStreetDto(data.street) : <MyEcabStreetDto>this.street;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.streetNumber = _data["streetNumber"] !== undefined ? _data["streetNumber"] : <any>null;
            this.streetNumberSuffix = _data["streetNumberSuffix"] !== undefined ? _data["streetNumberSuffix"] : <any>null;
            this.street = _data["street"] ? MyEcabStreetDto.fromJS(_data["street"]) : <any>null;
        }
    }

    static fromJS(data: any): MyEcabAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyEcabAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["streetNumber"] = this.streetNumber !== undefined ? this.streetNumber : <any>null;
        data["streetNumberSuffix"] = this.streetNumberSuffix !== undefined ? this.streetNumberSuffix : <any>null;
        data["street"] = this.street ? this.street.toJSON() : <any>null;
        return data;
    }
}

export interface IMyEcabAddressDto {
    id: number | null;
    streetNumber: string | null;
    streetNumberSuffix: string | null;
    street: IMyEcabStreetDto;

    [key: string]: any;
}

export class MyEcabLocalityDto implements IMyEcabLocalityDto {
    id!: number | null;
    name!: string | null;
    zipCode!: string | null;
    countryCode!: string | null;

    [key: string]: any;

    constructor(data?: IMyEcabLocalityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
        }
    }

    static fromJS(data: any): MyEcabLocalityDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyEcabLocalityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        return data;
    }
}

export interface IMyEcabLocalityDto {
    id: number | null;
    name: string | null;
    zipCode: string | null;
    countryCode: string | null;

    [key: string]: any;
}

export class MyEcabPersonAddressDto implements IMyEcabPersonAddressDto {
    id!: number | null;
    type!: MyEcabPersonAddressDtoType | null;
    complement!: string | null;
    address!: MyEcabAddressDto;

    [key: string]: any;

    constructor(data?: IMyEcabPersonAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new MyEcabAddressDto(data.address) : <MyEcabAddressDto>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.complement = _data["complement"] !== undefined ? _data["complement"] : <any>null;
            this.address = _data["address"] ? MyEcabAddressDto.fromJS(_data["address"]) : <any>null;
        }
    }

    static fromJS(data: any): MyEcabPersonAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyEcabPersonAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["complement"] = this.complement !== undefined ? this.complement : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        return data;
    }
}

export interface IMyEcabPersonAddressDto {
    id: number | null;
    type: MyEcabPersonAddressDtoType | null;
    complement: string | null;
    address: IMyEcabAddressDto;

    [key: string]: any;
}

export class MyEcabPersonCommunicationDto implements IMyEcabPersonCommunicationDto {
    id!: number | null;
    category!: MyEcabPersonCommunicationDtoCategory | null;
    type!: MyEcabPersonCommunicationDtoType | null;
    value!: string | null;
    principal!: boolean | null;

    [key: string]: any;

    constructor(data?: IMyEcabPersonCommunicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.principal = _data["principal"] !== undefined ? _data["principal"] : <any>null;
        }
    }

    static fromJS(data: any): MyEcabPersonCommunicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyEcabPersonCommunicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["principal"] = this.principal !== undefined ? this.principal : <any>null;
        return data;
    }
}

export interface IMyEcabPersonCommunicationDto {
    id: number | null;
    category: MyEcabPersonCommunicationDtoCategory | null;
    type: MyEcabPersonCommunicationDtoType | null;
    value: string | null;
    principal: boolean | null;

    [key: string]: any;
}

export class MyEcabPersonDto implements IMyEcabPersonDto {
    id!: number | null;
    type!: MyEcabPersonDtoType | null;
    companyName!: string | null;
    title!: MyEcabPersonDtoTitle | null;
    firstName!: string | null;
    lastName!: string | null;
    birthDate!: Date | null;
    languageCode!: string | null;
    principalIban!: string | null;
    myEcabLastModifiedDate!: Date | null;
    addresses!: MyEcabPersonAddressDto[] | null;
    communications!: MyEcabPersonCommunicationDto[] | null;

    [key: string]: any;

    constructor(data?: IMyEcabPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.addresses) {
                this.addresses = [];
                for (let i = 0; i < data.addresses.length; i++) {
                    let item = data.addresses[i];
                    this.addresses[i] = item && !(<any>item).toJSON ? new MyEcabPersonAddressDto(item) : <MyEcabPersonAddressDto>item;
                }
            }
            if (data.communications) {
                this.communications = [];
                for (let i = 0; i < data.communications.length; i++) {
                    let item = data.communications[i];
                    this.communications[i] = item && !(<any>item).toJSON ? new MyEcabPersonCommunicationDto(item) : <MyEcabPersonCommunicationDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.languageCode = _data["languageCode"] !== undefined ? _data["languageCode"] : <any>null;
            this.principalIban = _data["principalIban"] !== undefined ? _data["principalIban"] : <any>null;
            this.myEcabLastModifiedDate = _data["myEcabLastModifiedDate"] ? new Date(_data["myEcabLastModifiedDate"].toString()) : <any>null;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(MyEcabPersonAddressDto.fromJS(item));
            }
            else {
                this.addresses = <any>null;
            }
            if (Array.isArray(_data["communications"])) {
                this.communications = [] as any;
                for (let item of _data["communications"])
                    this.communications!.push(MyEcabPersonCommunicationDto.fromJS(item));
            }
            else {
                this.communications = <any>null;
            }
        }
    }

    static fromJS(data: any): MyEcabPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyEcabPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["birthDate"] = this.birthDate ? formatDate(this.birthDate) : <any>null;
        data["languageCode"] = this.languageCode !== undefined ? this.languageCode : <any>null;
        data["principalIban"] = this.principalIban !== undefined ? this.principalIban : <any>null;
        data["myEcabLastModifiedDate"] = this.myEcabLastModifiedDate ? this.myEcabLastModifiedDate.toISOString() : <any>null;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.communications)) {
            data["communications"] = [];
            for (let item of this.communications)
                data["communications"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IMyEcabPersonDto {
    id: number | null;
    type: MyEcabPersonDtoType | null;
    companyName: string | null;
    title: MyEcabPersonDtoTitle | null;
    firstName: string | null;
    lastName: string | null;
    birthDate: Date | null;
    languageCode: string | null;
    principalIban: string | null;
    myEcabLastModifiedDate: Date | null;
    addresses: IMyEcabPersonAddressDto[] | null;
    communications: IMyEcabPersonCommunicationDto[] | null;

    [key: string]: any;
}

export class MyEcabStreetDto implements IMyEcabStreetDto {
    id!: number | null;
    name!: string | null;
    locality!: MyEcabLocalityDto;

    [key: string]: any;

    constructor(data?: IMyEcabStreetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.locality = data.locality && !(<any>data.locality).toJSON ? new MyEcabLocalityDto(data.locality) : <MyEcabLocalityDto>this.locality;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.locality = _data["locality"] ? MyEcabLocalityDto.fromJS(_data["locality"]) : <any>null;
        }
    }

    static fromJS(data: any): MyEcabStreetDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyEcabStreetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["locality"] = this.locality ? this.locality.toJSON() : <any>null;
        return data;
    }
}

export interface IMyEcabStreetDto {
    id: number | null;
    name: string | null;
    locality: IMyEcabLocalityDto;

    [key: string]: any;
}

export class PageMyEcabPersonDto implements IPageMyEcabPersonDto {
    totalElements!: number | null;
    totalPages!: number | null;
    pageable!: PageableObject;
    first!: boolean | null;
    sort!: SortObject[] | null;
    number!: number | null;
    last!: boolean | null;
    numberOfElements!: number | null;
    size!: number | null;
    content!: MyEcabPersonDto[] | null;
    empty!: boolean | null;

    [key: string]: any;

    constructor(data?: IPageMyEcabPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.pageable = data.pageable && !(<any>data.pageable).toJSON ? new PageableObject(data.pageable) : <PageableObject>this.pageable;
            if (data.sort) {
                this.sort = [];
                for (let i = 0; i < data.sort.length; i++) {
                    let item = data.sort[i];
                    this.sort[i] = item && !(<any>item).toJSON ? new SortObject(item) : <SortObject>item;
                }
            }
            if (data.content) {
                this.content = [];
                for (let i = 0; i < data.content.length; i++) {
                    let item = data.content[i];
                    this.content[i] = item && !(<any>item).toJSON ? new MyEcabPersonDto(item) : <MyEcabPersonDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalElements = _data["totalElements"] !== undefined ? _data["totalElements"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.pageable = _data["pageable"] ? PageableObject.fromJS(_data["pageable"]) : <any>null;
            this.first = _data["first"] !== undefined ? _data["first"] : <any>null;
            if (Array.isArray(_data["sort"])) {
                this.sort = [] as any;
                for (let item of _data["sort"])
                    this.sort!.push(SortObject.fromJS(item));
            }
            else {
                this.sort = <any>null;
            }
            this.number = _data["number"] !== undefined ? _data["number"] : <any>null;
            this.last = _data["last"] !== undefined ? _data["last"] : <any>null;
            this.numberOfElements = _data["numberOfElements"] !== undefined ? _data["numberOfElements"] : <any>null;
            this.size = _data["size"] !== undefined ? _data["size"] : <any>null;
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(MyEcabPersonDto.fromJS(item));
            }
            else {
                this.content = <any>null;
            }
            this.empty = _data["empty"] !== undefined ? _data["empty"] : <any>null;
        }
    }

    static fromJS(data: any): PageMyEcabPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageMyEcabPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalElements"] = this.totalElements !== undefined ? this.totalElements : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["pageable"] = this.pageable ? this.pageable.toJSON() : <any>null;
        data["first"] = this.first !== undefined ? this.first : <any>null;
        if (Array.isArray(this.sort)) {
            data["sort"] = [];
            for (let item of this.sort)
                data["sort"].push(item ? item.toJSON() : <any>null);
        }
        data["number"] = this.number !== undefined ? this.number : <any>null;
        data["last"] = this.last !== undefined ? this.last : <any>null;
        data["numberOfElements"] = this.numberOfElements !== undefined ? this.numberOfElements : <any>null;
        data["size"] = this.size !== undefined ? this.size : <any>null;
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item ? item.toJSON() : <any>null);
        }
        data["empty"] = this.empty !== undefined ? this.empty : <any>null;
        return data;
    }
}

export interface IPageMyEcabPersonDto {
    totalElements: number | null;
    totalPages: number | null;
    pageable: IPageableObject;
    first: boolean | null;
    sort: ISortObject[] | null;
    number: number | null;
    last: boolean | null;
    numberOfElements: number | null;
    size: number | null;
    content: IMyEcabPersonDto[] | null;
    empty: boolean | null;

    [key: string]: any;
}

export class PageableObject implements IPageableObject {
    pageNumber!: number | null;
    sort!: SortObject[] | null;
    paged!: boolean | null;
    unpaged!: boolean | null;
    pageSize!: number | null;
    offset!: number | null;

    [key: string]: any;

    constructor(data?: IPageableObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.sort) {
                this.sort = [];
                for (let i = 0; i < data.sort.length; i++) {
                    let item = data.sort[i];
                    this.sort[i] = item && !(<any>item).toJSON ? new SortObject(item) : <SortObject>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            if (Array.isArray(_data["sort"])) {
                this.sort = [] as any;
                for (let item of _data["sort"])
                    this.sort!.push(SortObject.fromJS(item));
            }
            else {
                this.sort = <any>null;
            }
            this.paged = _data["paged"] !== undefined ? _data["paged"] : <any>null;
            this.unpaged = _data["unpaged"] !== undefined ? _data["unpaged"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
        }
    }

    static fromJS(data: any): PageableObject {
        data = typeof data === 'object' ? data : {};
        let result = new PageableObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        if (Array.isArray(this.sort)) {
            data["sort"] = [];
            for (let item of this.sort)
                data["sort"].push(item ? item.toJSON() : <any>null);
        }
        data["paged"] = this.paged !== undefined ? this.paged : <any>null;
        data["unpaged"] = this.unpaged !== undefined ? this.unpaged : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        return data;
    }
}

export interface IPageableObject {
    pageNumber: number | null;
    sort: ISortObject[] | null;
    paged: boolean | null;
    unpaged: boolean | null;
    pageSize: number | null;
    offset: number | null;

    [key: string]: any;
}

export class SortObject implements ISortObject {
    direction!: string | null;
    nullHandling!: string | null;
    ascending!: boolean | null;
    property!: string | null;
    ignoreCase!: boolean | null;

    [key: string]: any;

    constructor(data?: ISortObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.direction = _data["direction"] !== undefined ? _data["direction"] : <any>null;
            this.nullHandling = _data["nullHandling"] !== undefined ? _data["nullHandling"] : <any>null;
            this.ascending = _data["ascending"] !== undefined ? _data["ascending"] : <any>null;
            this.property = _data["property"] !== undefined ? _data["property"] : <any>null;
            this.ignoreCase = _data["ignoreCase"] !== undefined ? _data["ignoreCase"] : <any>null;
        }
    }

    static fromJS(data: any): SortObject {
        data = typeof data === 'object' ? data : {};
        let result = new SortObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["direction"] = this.direction !== undefined ? this.direction : <any>null;
        data["nullHandling"] = this.nullHandling !== undefined ? this.nullHandling : <any>null;
        data["ascending"] = this.ascending !== undefined ? this.ascending : <any>null;
        data["property"] = this.property !== undefined ? this.property : <any>null;
        data["ignoreCase"] = this.ignoreCase !== undefined ? this.ignoreCase : <any>null;
        return data;
    }
}

export interface ISortObject {
    direction: string | null;
    nullHandling: string | null;
    ascending: boolean | null;
    property: string | null;
    ignoreCase: boolean | null;

    [key: string]: any;
}

export class Pageable implements IPageable {
    page!: number;
    size!: number;
    sort!: string[];

    [key: string]: any;

    constructor(data?: IPageable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.size = _data["size"] !== undefined ? _data["size"] : <any>null;
            if (Array.isArray(_data["sort"])) {
                this.sort = [] as any;
                for (let item of _data["sort"])
                    this.sort!.push(item);
            }
            else {
                this.sort = <any>null;
            }
        }
    }

    static fromJS(data: any): Pageable {
        data = typeof data === 'object' ? data : {};
        let result = new Pageable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["size"] = this.size !== undefined ? this.size : <any>null;
        if (Array.isArray(this.sort)) {
            data["sort"] = [];
            for (let item of this.sort)
                data["sort"].push(item);
        }
        return data;
    }
}

export interface IPageable {
    page: number;
    size: number;
    sort: string[];

    [key: string]: any;
}

export class PageMessageDto implements IPageMessageDto {
    totalPages!: number;
    totalElements!: number;
    size!: number;
    content!: MessageDto[];
    number!: number;
    sort!: SortObject;
    pageable!: PageableObject;
    numberOfElements!: number;
    first!: boolean;
    last!: boolean;
    empty!: boolean;

    [key: string]: any;

    constructor(data?: IPageMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.content) {
                this.content = [];
                for (let i = 0; i < data.content.length; i++) {
                    let item = data.content[i];
                    this.content[i] = item && !(<any>item).toJSON ? new MessageDto(item) : <MessageDto>item;
                }
            }
            this.sort = data.sort && !(<any>data.sort).toJSON ? new SortObject(data.sort) : <SortObject>this.sort;
            this.pageable = data.pageable && !(<any>data.pageable).toJSON ? new PageableObject(data.pageable) : <PageableObject>this.pageable;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.totalElements = _data["totalElements"] !== undefined ? _data["totalElements"] : <any>null;
            this.size = _data["size"] !== undefined ? _data["size"] : <any>null;
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(MessageDto.fromJS(item));
            }
            else {
                this.content = <any>null;
            }
            this.number = _data["number"] !== undefined ? _data["number"] : <any>null;
            this.sort = _data["sort"] ? SortObject.fromJS(_data["sort"]) : <any>null;
            this.pageable = _data["pageable"] ? PageableObject.fromJS(_data["pageable"]) : <any>null;
            this.numberOfElements = _data["numberOfElements"] !== undefined ? _data["numberOfElements"] : <any>null;
            this.first = _data["first"] !== undefined ? _data["first"] : <any>null;
            this.last = _data["last"] !== undefined ? _data["last"] : <any>null;
            this.empty = _data["empty"] !== undefined ? _data["empty"] : <any>null;
        }
    }

    static fromJS(data: any): PageMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["totalElements"] = this.totalElements !== undefined ? this.totalElements : <any>null;
        data["size"] = this.size !== undefined ? this.size : <any>null;
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item ? item.toJSON() : <any>null);
        }
        data["number"] = this.number !== undefined ? this.number : <any>null;
        data["sort"] = this.sort ? this.sort.toJSON() : <any>null;
        data["pageable"] = this.pageable ? this.pageable.toJSON() : <any>null;
        data["numberOfElements"] = this.numberOfElements !== undefined ? this.numberOfElements : <any>null;
        data["first"] = this.first !== undefined ? this.first : <any>null;
        data["last"] = this.last !== undefined ? this.last : <any>null;
        data["empty"] = this.empty !== undefined ? this.empty : <any>null;
        return data;
    }
}

export interface IPageMessageDto {
    totalPages: number;
    totalElements: number;
    size: number;
    content: IMessageDto[];
    number: number;
    sort: ISortObject;
    pageable: IPageableObject;
    numberOfElements: number;
    first: boolean;
    last: boolean;
    empty: boolean;

    [key: string]: any;
}

export class OpenMessagesGroupedDto implements IOpenMessagesGroupedDto {
    assignedToMe!: MessageDto[];
    unassigned!: MessageDto[];
    assignedToOthers!: MessageDto[];

    [key: string]: any;

    constructor(data?: IOpenMessagesGroupedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.assignedToMe) {
                this.assignedToMe = [];
                for (let i = 0; i < data.assignedToMe.length; i++) {
                    let item = data.assignedToMe[i];
                    this.assignedToMe[i] = item && !(<any>item).toJSON ? new MessageDto(item) : <MessageDto>item;
                }
            }
            if (data.unassigned) {
                this.unassigned = [];
                for (let i = 0; i < data.unassigned.length; i++) {
                    let item = data.unassigned[i];
                    this.unassigned[i] = item && !(<any>item).toJSON ? new MessageDto(item) : <MessageDto>item;
                }
            }
            if (data.assignedToOthers) {
                this.assignedToOthers = [];
                for (let i = 0; i < data.assignedToOthers.length; i++) {
                    let item = data.assignedToOthers[i];
                    this.assignedToOthers[i] = item && !(<any>item).toJSON ? new MessageDto(item) : <MessageDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["assignedToMe"])) {
                this.assignedToMe = [] as any;
                for (let item of _data["assignedToMe"])
                    this.assignedToMe!.push(MessageDto.fromJS(item));
            }
            else {
                this.assignedToMe = <any>null;
            }
            if (Array.isArray(_data["unassigned"])) {
                this.unassigned = [] as any;
                for (let item of _data["unassigned"])
                    this.unassigned!.push(MessageDto.fromJS(item));
            }
            else {
                this.unassigned = <any>null;
            }
            if (Array.isArray(_data["assignedToOthers"])) {
                this.assignedToOthers = [] as any;
                for (let item of _data["assignedToOthers"])
                    this.assignedToOthers!.push(MessageDto.fromJS(item));
            }
            else {
                this.assignedToOthers = <any>null;
            }
        }
    }

    static fromJS(data: any): OpenMessagesGroupedDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpenMessagesGroupedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.assignedToMe)) {
            data["assignedToMe"] = [];
            for (let item of this.assignedToMe)
                data["assignedToMe"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.unassigned)) {
            data["unassigned"] = [];
            for (let item of this.unassigned)
                data["unassigned"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.assignedToOthers)) {
            data["assignedToOthers"] = [];
            for (let item of this.assignedToOthers)
                data["assignedToOthers"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IOpenMessagesGroupedDto {
    assignedToMe: IMessageDto[];
    unassigned: IMessageDto[];
    assignedToOthers: IMessageDto[];

    [key: string]: any;
}

export class FilterSelectionDto implements IFilterSelectionDto {
    mode!: FilterSelectionDtoMode;
    values!: string[];

    [key: string]: any;

    constructor(data?: IFilterSelectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.mode = _data["mode"] !== undefined ? _data["mode"] : <any>null;
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            else {
                this.values = <any>null;
            }
        }
    }

    static fromJS(data: any): FilterSelectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterSelectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["mode"] = this.mode !== undefined ? this.mode : <any>null;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IFilterSelectionDto {
    mode: FilterSelectionDtoMode;
    values: string[];

    [key: string]: any;
}

export class MessageFilterCriteriaDto implements IMessageFilterCriteriaDto {
    query!: string;
    subject!: SubjectSubstringFilterDto;
    people!: FilterSelectionDto;
    building!: FilterSelectionDto;
    caseId!: string;
    townGroupIds!: string[];
    caseType!: MessageFilterCriteriaDtoCaseType;
    questionType!: MessageFilterCriteriaDtoQuestionType;
    assignedCollaboratorId!: string;

    [key: string]: any;

    constructor(data?: IMessageFilterCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.subject = data.subject && !(<any>data.subject).toJSON ? new SubjectSubstringFilterDto(data.subject) : <SubjectSubstringFilterDto>this.subject;
            this.people = data.people && !(<any>data.people).toJSON ? new FilterSelectionDto(data.people) : <FilterSelectionDto>this.people;
            this.building = data.building && !(<any>data.building).toJSON ? new FilterSelectionDto(data.building) : <FilterSelectionDto>this.building;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.query = _data["query"] !== undefined ? _data["query"] : <any>null;
            this.subject = _data["subject"] ? SubjectSubstringFilterDto.fromJS(_data["subject"]) : <any>null;
            this.people = _data["people"] ? FilterSelectionDto.fromJS(_data["people"]) : <any>null;
            this.building = _data["building"] ? FilterSelectionDto.fromJS(_data["building"]) : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            if (Array.isArray(_data["townGroupIds"])) {
                this.townGroupIds = [] as any;
                for (let item of _data["townGroupIds"])
                    this.townGroupIds!.push(item);
            }
            else {
                this.townGroupIds = <any>null;
            }
            this.caseType = _data["caseType"] !== undefined ? _data["caseType"] : <any>null;
            this.questionType = _data["questionType"] !== undefined ? _data["questionType"] : <any>null;
            this.assignedCollaboratorId = _data["assignedCollaboratorId"] !== undefined ? _data["assignedCollaboratorId"] : <any>null;
        }
    }

    static fromJS(data: any): MessageFilterCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageFilterCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["query"] = this.query !== undefined ? this.query : <any>null;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>null;
        data["people"] = this.people ? this.people.toJSON() : <any>null;
        data["building"] = this.building ? this.building.toJSON() : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        if (Array.isArray(this.townGroupIds)) {
            data["townGroupIds"] = [];
            for (let item of this.townGroupIds)
                data["townGroupIds"].push(item);
        }
        data["caseType"] = this.caseType !== undefined ? this.caseType : <any>null;
        data["questionType"] = this.questionType !== undefined ? this.questionType : <any>null;
        data["assignedCollaboratorId"] = this.assignedCollaboratorId !== undefined ? this.assignedCollaboratorId : <any>null;
        return data;
    }
}

export interface IMessageFilterCriteriaDto {
    query: string;
    subject: ISubjectSubstringFilterDto;
    people: IFilterSelectionDto;
    building: IFilterSelectionDto;
    caseId: string;
    townGroupIds: string[];
    caseType: MessageFilterCriteriaDtoCaseType;
    questionType: MessageFilterCriteriaDtoQuestionType;
    assignedCollaboratorId: string;

    [key: string]: any;
}

export class PredefinedMessageFilterDto implements IPredefinedMessageFilterDto {
    identifier!: string;
    name!: string;
    targetView!: PredefinedMessageFilterDtoTargetView;
    criteria!: MessageFilterCriteriaDto;

    [key: string]: any;

    constructor(data?: IPredefinedMessageFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.criteria = data.criteria && !(<any>data.criteria).toJSON ? new MessageFilterCriteriaDto(data.criteria) : <MessageFilterCriteriaDto>this.criteria;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.identifier = _data["identifier"] !== undefined ? _data["identifier"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.targetView = _data["targetView"] !== undefined ? _data["targetView"] : <any>null;
            this.criteria = _data["criteria"] ? MessageFilterCriteriaDto.fromJS(_data["criteria"]) : <any>null;
        }
    }

    static fromJS(data: any): PredefinedMessageFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedMessageFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["identifier"] = this.identifier !== undefined ? this.identifier : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["targetView"] = this.targetView !== undefined ? this.targetView : <any>null;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>null;
        return data;
    }
}

export interface IPredefinedMessageFilterDto {
    identifier: string;
    name: string;
    targetView: PredefinedMessageFilterDtoTargetView;
    criteria: IMessageFilterCriteriaDto;

    [key: string]: any;
}

export class SubjectSubstringFilterDto implements ISubjectSubstringFilterDto {
    includesAny!: string[];
    excludesAny!: string[];

    [key: string]: any;

    constructor(data?: ISubjectSubstringFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["includesAny"])) {
                this.includesAny = [] as any;
                for (let item of _data["includesAny"])
                    this.includesAny!.push(item);
            }
            else {
                this.includesAny = <any>null;
            }
            if (Array.isArray(_data["excludesAny"])) {
                this.excludesAny = [] as any;
                for (let item of _data["excludesAny"])
                    this.excludesAny!.push(item);
            }
            else {
                this.excludesAny = <any>null;
            }
        }
    }

    static fromJS(data: any): SubjectSubstringFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectSubstringFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.includesAny)) {
            data["includesAny"] = [];
            for (let item of this.includesAny)
                data["includesAny"].push(item);
        }
        if (Array.isArray(this.excludesAny)) {
            data["excludesAny"] = [];
            for (let item of this.excludesAny)
                data["excludesAny"].push(item);
        }
        return data;
    }
}

export interface ISubjectSubstringFilterDto {
    includesAny: string[];
    excludesAny: string[];

    [key: string]: any;
}

export class MyEcabBuildingSummaryDto implements IMyEcabBuildingSummaryDto {
    id!: number | null;
    buildingState!: MyEcabBuildingSummaryDtoBuildingState | null;
    egidNumber!: number | null;
    aeaiCode!: string | null;
    aeaiUsage!: string | null;
    principal!: boolean | null;
    address!: MyEcabAddressDto;

    [key: string]: any;

    constructor(data?: IMyEcabBuildingSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.address = data.address && !(<any>data.address).toJSON ? new MyEcabAddressDto(data.address) : <MyEcabAddressDto>this.address;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.buildingState = _data["buildingState"] !== undefined ? _data["buildingState"] : <any>null;
            this.egidNumber = _data["egidNumber"] !== undefined ? _data["egidNumber"] : <any>null;
            this.aeaiCode = _data["aeaiCode"] !== undefined ? _data["aeaiCode"] : <any>null;
            this.aeaiUsage = _data["aeaiUsage"] !== undefined ? _data["aeaiUsage"] : <any>null;
            this.principal = _data["principal"] !== undefined ? _data["principal"] : <any>null;
            this.address = _data["address"] ? MyEcabAddressDto.fromJS(_data["address"]) : <any>null;
        }
    }

    static fromJS(data: any): MyEcabBuildingSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyEcabBuildingSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["buildingState"] = this.buildingState !== undefined ? this.buildingState : <any>null;
        data["egidNumber"] = this.egidNumber !== undefined ? this.egidNumber : <any>null;
        data["aeaiCode"] = this.aeaiCode !== undefined ? this.aeaiCode : <any>null;
        data["aeaiUsage"] = this.aeaiUsage !== undefined ? this.aeaiUsage : <any>null;
        data["principal"] = this.principal !== undefined ? this.principal : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        return data;
    }
}

export interface IMyEcabBuildingSummaryDto {
    id: number | null;
    buildingState: MyEcabBuildingSummaryDtoBuildingState | null;
    egidNumber: number | null;
    aeaiCode: string | null;
    aeaiUsage: string | null;
    principal: boolean | null;
    address: IMyEcabAddressDto;

    [key: string]: any;
}

export class MyEcabIncidentSummaryDto implements IMyEcabIncidentSummaryDto {
    id!: number | null;
    incidentNumberFull!: string | null;
    incidentYear!: number | null;
    announcementDate!: Date | null;
    date!: Date | null;
    lastModifiedDate!: Date | null;
    workflowState!: MyEcabIncidentSummaryDtoWorkflowState | null;
    status!: MyEcabIncidentSummaryDtoStatus | null;
    notCoveredByEcab!: boolean | null;
    incidentTypeCode!: string | null;
    incidentType!: string | null;
    eventTypeCode!: string | null;
    eventType!: string | null;
    incidentCause!: string | null;
    incidentSubCause!: string | null;
    building!: MyEcabBuildingSummaryDto;
    insuranceContract!: MyEcabInsuranceContractDto;

    [key: string]: any;

    constructor(data?: IMyEcabIncidentSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.building = data.building && !(<any>data.building).toJSON ? new MyEcabBuildingSummaryDto(data.building) : <MyEcabBuildingSummaryDto>this.building;
            this.insuranceContract = data.insuranceContract && !(<any>data.insuranceContract).toJSON ? new MyEcabInsuranceContractDto(data.insuranceContract) : <MyEcabInsuranceContractDto>this.insuranceContract;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.incidentNumberFull = _data["incidentNumberFull"] !== undefined ? _data["incidentNumberFull"] : <any>null;
            this.incidentYear = _data["incidentYear"] !== undefined ? _data["incidentYear"] : <any>null;
            this.announcementDate = _data["announcementDate"] ? new Date(_data["announcementDate"].toString()) : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>null;
            this.workflowState = _data["workflowState"] !== undefined ? _data["workflowState"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.notCoveredByEcab = _data["notCoveredByEcab"] !== undefined ? _data["notCoveredByEcab"] : <any>null;
            this.incidentTypeCode = _data["incidentTypeCode"] !== undefined ? _data["incidentTypeCode"] : <any>null;
            this.incidentType = _data["incidentType"] !== undefined ? _data["incidentType"] : <any>null;
            this.eventTypeCode = _data["eventTypeCode"] !== undefined ? _data["eventTypeCode"] : <any>null;
            this.eventType = _data["eventType"] !== undefined ? _data["eventType"] : <any>null;
            this.incidentCause = _data["incidentCause"] !== undefined ? _data["incidentCause"] : <any>null;
            this.incidentSubCause = _data["incidentSubCause"] !== undefined ? _data["incidentSubCause"] : <any>null;
            this.building = _data["building"] ? MyEcabBuildingSummaryDto.fromJS(_data["building"]) : <any>null;
            this.insuranceContract = _data["insuranceContract"] ? MyEcabInsuranceContractDto.fromJS(_data["insuranceContract"]) : <any>null;
        }
    }

    static fromJS(data: any): MyEcabIncidentSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyEcabIncidentSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["incidentNumberFull"] = this.incidentNumberFull !== undefined ? this.incidentNumberFull : <any>null;
        data["incidentYear"] = this.incidentYear !== undefined ? this.incidentYear : <any>null;
        data["announcementDate"] = this.announcementDate ? formatDate(this.announcementDate) : <any>null;
        data["date"] = this.date ? formatDate(this.date) : <any>null;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>null;
        data["workflowState"] = this.workflowState !== undefined ? this.workflowState : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["notCoveredByEcab"] = this.notCoveredByEcab !== undefined ? this.notCoveredByEcab : <any>null;
        data["incidentTypeCode"] = this.incidentTypeCode !== undefined ? this.incidentTypeCode : <any>null;
        data["incidentType"] = this.incidentType !== undefined ? this.incidentType : <any>null;
        data["eventTypeCode"] = this.eventTypeCode !== undefined ? this.eventTypeCode : <any>null;
        data["eventType"] = this.eventType !== undefined ? this.eventType : <any>null;
        data["incidentCause"] = this.incidentCause !== undefined ? this.incidentCause : <any>null;
        data["incidentSubCause"] = this.incidentSubCause !== undefined ? this.incidentSubCause : <any>null;
        data["building"] = this.building ? this.building.toJSON() : <any>null;
        data["insuranceContract"] = this.insuranceContract ? this.insuranceContract.toJSON() : <any>null;
        return data;
    }
}

export interface IMyEcabIncidentSummaryDto {
    id: number | null;
    incidentNumberFull: string | null;
    incidentYear: number | null;
    announcementDate: Date | null;
    date: Date | null;
    lastModifiedDate: Date | null;
    workflowState: MyEcabIncidentSummaryDtoWorkflowState | null;
    status: MyEcabIncidentSummaryDtoStatus | null;
    notCoveredByEcab: boolean | null;
    incidentTypeCode: string | null;
    incidentType: string | null;
    eventTypeCode: string | null;
    eventType: string | null;
    incidentCause: string | null;
    incidentSubCause: string | null;
    building: IMyEcabBuildingSummaryDto;
    insuranceContract: IMyEcabInsuranceContractDto;

    [key: string]: any;
}

export class MyEcabInsuranceContractDto implements IMyEcabInsuranceContractDto {
    id!: number | null;
    insuranceNumber!: number | null;
    type!: MyEcabInsuranceContractDtoType | null;
    languageCode!: string | null;
    owners!: MyEcabPersonDto[] | null;

    [key: string]: any;

    constructor(data?: IMyEcabInsuranceContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.owners) {
                this.owners = [];
                for (let i = 0; i < data.owners.length; i++) {
                    let item = data.owners[i];
                    this.owners[i] = item && !(<any>item).toJSON ? new MyEcabPersonDto(item) : <MyEcabPersonDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.insuranceNumber = _data["insuranceNumber"] !== undefined ? _data["insuranceNumber"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.languageCode = _data["languageCode"] !== undefined ? _data["languageCode"] : <any>null;
            if (Array.isArray(_data["owners"])) {
                this.owners = [] as any;
                for (let item of _data["owners"])
                    this.owners!.push(MyEcabPersonDto.fromJS(item));
            }
            else {
                this.owners = <any>null;
            }
        }
    }

    static fromJS(data: any): MyEcabInsuranceContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyEcabInsuranceContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["insuranceNumber"] = this.insuranceNumber !== undefined ? this.insuranceNumber : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["languageCode"] = this.languageCode !== undefined ? this.languageCode : <any>null;
        if (Array.isArray(this.owners)) {
            data["owners"] = [];
            for (let item of this.owners)
                data["owners"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IMyEcabInsuranceContractDto {
    id: number | null;
    insuranceNumber: number | null;
    type: MyEcabInsuranceContractDtoType | null;
    languageCode: string | null;
    owners: IMyEcabPersonDto[] | null;

    [key: string]: any;
}

export class PageMyEcabIncidentSummaryDto implements IPageMyEcabIncidentSummaryDto {
    totalElements!: number | null;
    totalPages!: number | null;
    pageable!: PageableObject;
    first!: boolean | null;
    sort!: SortObject[] | null;
    number!: number | null;
    last!: boolean | null;
    numberOfElements!: number | null;
    size!: number | null;
    content!: MyEcabIncidentSummaryDto[] | null;
    empty!: boolean | null;

    [key: string]: any;

    constructor(data?: IPageMyEcabIncidentSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.pageable = data.pageable && !(<any>data.pageable).toJSON ? new PageableObject(data.pageable) : <PageableObject>this.pageable;
            if (data.sort) {
                this.sort = [];
                for (let i = 0; i < data.sort.length; i++) {
                    let item = data.sort[i];
                    this.sort[i] = item && !(<any>item).toJSON ? new SortObject(item) : <SortObject>item;
                }
            }
            if (data.content) {
                this.content = [];
                for (let i = 0; i < data.content.length; i++) {
                    let item = data.content[i];
                    this.content[i] = item && !(<any>item).toJSON ? new MyEcabIncidentSummaryDto(item) : <MyEcabIncidentSummaryDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalElements = _data["totalElements"] !== undefined ? _data["totalElements"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.pageable = _data["pageable"] ? PageableObject.fromJS(_data["pageable"]) : <any>null;
            this.first = _data["first"] !== undefined ? _data["first"] : <any>null;
            if (Array.isArray(_data["sort"])) {
                this.sort = [] as any;
                for (let item of _data["sort"])
                    this.sort!.push(SortObject.fromJS(item));
            }
            else {
                this.sort = <any>null;
            }
            this.number = _data["number"] !== undefined ? _data["number"] : <any>null;
            this.last = _data["last"] !== undefined ? _data["last"] : <any>null;
            this.numberOfElements = _data["numberOfElements"] !== undefined ? _data["numberOfElements"] : <any>null;
            this.size = _data["size"] !== undefined ? _data["size"] : <any>null;
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(MyEcabIncidentSummaryDto.fromJS(item));
            }
            else {
                this.content = <any>null;
            }
            this.empty = _data["empty"] !== undefined ? _data["empty"] : <any>null;
        }
    }

    static fromJS(data: any): PageMyEcabIncidentSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageMyEcabIncidentSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalElements"] = this.totalElements !== undefined ? this.totalElements : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["pageable"] = this.pageable ? this.pageable.toJSON() : <any>null;
        data["first"] = this.first !== undefined ? this.first : <any>null;
        if (Array.isArray(this.sort)) {
            data["sort"] = [];
            for (let item of this.sort)
                data["sort"].push(item ? item.toJSON() : <any>null);
        }
        data["number"] = this.number !== undefined ? this.number : <any>null;
        data["last"] = this.last !== undefined ? this.last : <any>null;
        data["numberOfElements"] = this.numberOfElements !== undefined ? this.numberOfElements : <any>null;
        data["size"] = this.size !== undefined ? this.size : <any>null;
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item ? item.toJSON() : <any>null);
        }
        data["empty"] = this.empty !== undefined ? this.empty : <any>null;
        return data;
    }
}

export interface IPageMyEcabIncidentSummaryDto {
    totalElements: number | null;
    totalPages: number | null;
    pageable: IPageableObject;
    first: boolean | null;
    sort: ISortObject[] | null;
    number: number | null;
    last: boolean | null;
    numberOfElements: number | null;
    size: number | null;
    content: IMyEcabIncidentSummaryDto[] | null;
    empty: boolean | null;

    [key: string]: any;
}

export class IcareDocumentTypeOptionDto implements IIcareDocumentTypeOptionDto {
    value!: string;
    label!: string;

    [key: string]: any;

    constructor(data?: IIcareDocumentTypeOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
        }
    }

    static fromJS(data: any): IcareDocumentTypeOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IcareDocumentTypeOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        return data;
    }
}

export interface IIcareDocumentTypeOptionDto {
    value: string;
    label: string;

    [key: string]: any;
}

export class CollaboratorDto implements ICollaboratorDto {
    id!: string;
    email!: string;
    firstname!: string;
    lastname!: string;

    [key: string]: any;

    constructor(data?: ICollaboratorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : <any>null;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : <any>null;
        }
    }

    static fromJS(data: any): CollaboratorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollaboratorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["firstname"] = this.firstname !== undefined ? this.firstname : <any>null;
        data["lastname"] = this.lastname !== undefined ? this.lastname : <any>null;
        return data;
    }
}

export interface ICollaboratorDto {
    id: string;
    email: string;
    firstname: string;
    lastname: string;

    [key: string]: any;
}

export class PageMyEcabBuildingSummaryDto implements IPageMyEcabBuildingSummaryDto {
    totalElements!: number | null;
    totalPages!: number | null;
    pageable!: PageableObject;
    first!: boolean | null;
    sort!: SortObject[] | null;
    number!: number | null;
    last!: boolean | null;
    numberOfElements!: number | null;
    size!: number | null;
    content!: MyEcabBuildingSummaryDto[] | null;
    empty!: boolean | null;

    [key: string]: any;

    constructor(data?: IPageMyEcabBuildingSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.pageable = data.pageable && !(<any>data.pageable).toJSON ? new PageableObject(data.pageable) : <PageableObject>this.pageable;
            if (data.sort) {
                this.sort = [];
                for (let i = 0; i < data.sort.length; i++) {
                    let item = data.sort[i];
                    this.sort[i] = item && !(<any>item).toJSON ? new SortObject(item) : <SortObject>item;
                }
            }
            if (data.content) {
                this.content = [];
                for (let i = 0; i < data.content.length; i++) {
                    let item = data.content[i];
                    this.content[i] = item && !(<any>item).toJSON ? new MyEcabBuildingSummaryDto(item) : <MyEcabBuildingSummaryDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalElements = _data["totalElements"] !== undefined ? _data["totalElements"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
            this.pageable = _data["pageable"] ? PageableObject.fromJS(_data["pageable"]) : <any>null;
            this.first = _data["first"] !== undefined ? _data["first"] : <any>null;
            if (Array.isArray(_data["sort"])) {
                this.sort = [] as any;
                for (let item of _data["sort"])
                    this.sort!.push(SortObject.fromJS(item));
            }
            else {
                this.sort = <any>null;
            }
            this.number = _data["number"] !== undefined ? _data["number"] : <any>null;
            this.last = _data["last"] !== undefined ? _data["last"] : <any>null;
            this.numberOfElements = _data["numberOfElements"] !== undefined ? _data["numberOfElements"] : <any>null;
            this.size = _data["size"] !== undefined ? _data["size"] : <any>null;
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(MyEcabBuildingSummaryDto.fromJS(item));
            }
            else {
                this.content = <any>null;
            }
            this.empty = _data["empty"] !== undefined ? _data["empty"] : <any>null;
        }
    }

    static fromJS(data: any): PageMyEcabBuildingSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageMyEcabBuildingSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalElements"] = this.totalElements !== undefined ? this.totalElements : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        data["pageable"] = this.pageable ? this.pageable.toJSON() : <any>null;
        data["first"] = this.first !== undefined ? this.first : <any>null;
        if (Array.isArray(this.sort)) {
            data["sort"] = [];
            for (let item of this.sort)
                data["sort"].push(item ? item.toJSON() : <any>null);
        }
        data["number"] = this.number !== undefined ? this.number : <any>null;
        data["last"] = this.last !== undefined ? this.last : <any>null;
        data["numberOfElements"] = this.numberOfElements !== undefined ? this.numberOfElements : <any>null;
        data["size"] = this.size !== undefined ? this.size : <any>null;
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item ? item.toJSON() : <any>null);
        }
        data["empty"] = this.empty !== undefined ? this.empty : <any>null;
        return data;
    }
}

export interface IPageMyEcabBuildingSummaryDto {
    totalElements: number | null;
    totalPages: number | null;
    pageable: IPageableObject;
    first: boolean | null;
    sort: ISortObject[] | null;
    number: number | null;
    last: boolean | null;
    numberOfElements: number | null;
    size: number | null;
    content: IMyEcabBuildingSummaryDto[] | null;
    empty: boolean | null;

    [key: string]: any;
}

export enum BuildingMode {
    ALL = "ALL",
    EMPTY = "EMPTY",
    SELECTED_VALUES = "SELECTED_VALUES",
}

export enum PersonMode {
    ALL = "ALL",
    EMPTY = "EMPTY",
    SELECTED_VALUES = "SELECTED_VALUES",
}

export enum CaseType {
    NONE = "NONE",
    DAMAGE = "DAMAGE",
    ESTIMATION = "ESTIMATION",
    SUBSIDY = "SUBSIDY",
}

export enum QuestionType {
    MY_ACCOUNT = "MY_ACCOUNT",
    GENERAL_QUESTION = "GENERAL_QUESTION",
    CLAIM = "CLAIM",
    PREVENTION = "PREVENTION",
    ESTIMATION = "ESTIMATION",
    BUILDINGS = "BUILDINGS",
    SINISTRE = "SINISTRE",
    SUBSIDIES = "SUBSIDIES",
}

export enum BuildingMode2 {
    ALL = "ALL",
    EMPTY = "EMPTY",
    SELECTED_VALUES = "SELECTED_VALUES",
}

export enum PersonMode2 {
    ALL = "ALL",
    EMPTY = "EMPTY",
    SELECTED_VALUES = "SELECTED_VALUES",
}

export enum CaseType2 {
    NONE = "NONE",
    DAMAGE = "DAMAGE",
    ESTIMATION = "ESTIMATION",
    SUBSIDY = "SUBSIDY",
}

export enum QuestionType2 {
    MY_ACCOUNT = "MY_ACCOUNT",
    GENERAL_QUESTION = "GENERAL_QUESTION",
    CLAIM = "CLAIM",
    PREVENTION = "PREVENTION",
    ESTIMATION = "ESTIMATION",
    BUILDINGS = "BUILDINGS",
    SINISTRE = "SINISTRE",
    SUBSIDIES = "SUBSIDIES",
}

export enum UpdateMessageStatusDtoStatus {
    OPEN = "OPEN",
    HANDLED = "HANDLED",
}

export enum MessageDtoDirection {
    IN = "IN",
    OUT = "OUT",
}

export enum MessageDtoChannel {
    PORTAL = "PORTAL",
    MAIL = "MAIL",
    PHONE = "PHONE",
    LETTER = "LETTER",
}

export enum MessageDtoCaseType {
    NONE = "NONE",
    DAMAGE = "DAMAGE",
    ESTIMATION = "ESTIMATION",
    SUBSIDY = "SUBSIDY",
}

export enum MessageDtoStatus {
    OPEN = "OPEN",
    HANDLED = "HANDLED",
}

export enum MessageDtoQuestionType {
    MY_ACCOUNT = "MY_ACCOUNT",
    GENERAL_QUESTION = "GENERAL_QUESTION",
    CLAIM = "CLAIM",
    PREVENTION = "PREVENTION",
    ESTIMATION = "ESTIMATION",
    BUILDINGS = "BUILDINGS",
    SINISTRE = "SINISTRE",
    SUBSIDIES = "SUBSIDIES",
}

export enum UpdateMessageQuestionTypeDtoQuestionType {
    MY_ACCOUNT = "MY_ACCOUNT",
    GENERAL_QUESTION = "GENERAL_QUESTION",
    CLAIM = "CLAIM",
    PREVENTION = "PREVENTION",
    ESTIMATION = "ESTIMATION",
    BUILDINGS = "BUILDINGS",
    SINISTRE = "SINISTRE",
    SUBSIDIES = "SUBSIDIES",
}

export enum UpdateContextMessageDtoCaseType {
    NONE = "NONE",
    DAMAGE = "DAMAGE",
    ESTIMATION = "ESTIMATION",
    SUBSIDY = "SUBSIDY",
}

export enum UpdateContextMessageDtoQuestionType {
    MY_ACCOUNT = "MY_ACCOUNT",
    GENERAL_QUESTION = "GENERAL_QUESTION",
    CLAIM = "CLAIM",
    PREVENTION = "PREVENTION",
    ESTIMATION = "ESTIMATION",
    BUILDINGS = "BUILDINGS",
    SINISTRE = "SINISTRE",
    SUBSIDIES = "SUBSIDIES",
}

export enum UpdateMessageCaseDtoCaseType {
    NONE = "NONE",
    DAMAGE = "DAMAGE",
    ESTIMATION = "ESTIMATION",
    SUBSIDY = "SUBSIDY",
}

export enum ReplyMessageDtoDirection {
    IN = "IN",
    OUT = "OUT",
}

export enum ReplyMessageDtoChannel {
    PORTAL = "PORTAL",
    MAIL = "MAIL",
    PHONE = "PHONE",
    LETTER = "LETTER",
}

export enum AttachmentDtoKind {
    FILE = "FILE",
    LINK = "LINK",
}

export enum MessageWithAttachmentsDtoDirection {
    IN = "IN",
    OUT = "OUT",
}

export enum MessageWithAttachmentsDtoChannel {
    PORTAL = "PORTAL",
    MAIL = "MAIL",
    PHONE = "PHONE",
    LETTER = "LETTER",
}

export enum MessageWithAttachmentsDtoCaseType {
    NONE = "NONE",
    DAMAGE = "DAMAGE",
    ESTIMATION = "ESTIMATION",
    SUBSIDY = "SUBSIDY",
}

export enum MessageWithAttachmentsDtoStatus {
    OPEN = "OPEN",
    HANDLED = "HANDLED",
}

export enum MessageWithAttachmentsDtoQuestionType {
    MY_ACCOUNT = "MY_ACCOUNT",
    GENERAL_QUESTION = "GENERAL_QUESTION",
    CLAIM = "CLAIM",
    PREVENTION = "PREVENTION",
    ESTIMATION = "ESTIMATION",
    BUILDINGS = "BUILDINGS",
    SINISTRE = "SINISTRE",
    SUBSIDIES = "SUBSIDIES",
}

export enum BulkUpdateMessageContextDtoCaseType {
    NONE = "NONE",
    DAMAGE = "DAMAGE",
    ESTIMATION = "ESTIMATION",
    SUBSIDY = "SUBSIDY",
}

export enum BulkUpdateMessageContextDtoQuestionType {
    MY_ACCOUNT = "MY_ACCOUNT",
    GENERAL_QUESTION = "GENERAL_QUESTION",
    CLAIM = "CLAIM",
    PREVENTION = "PREVENTION",
    ESTIMATION = "ESTIMATION",
    BUILDINGS = "BUILDINGS",
    SINISTRE = "SINISTRE",
    SUBSIDIES = "SUBSIDIES",
}

export enum CreateMessageDtoDirection {
    IN = "IN",
    OUT = "OUT",
}

export enum CreateMessageDtoChannel {
    PORTAL = "PORTAL",
    MAIL = "MAIL",
    PHONE = "PHONE",
    LETTER = "LETTER",
}

export enum CreateMessageDtoCaseType {
    NONE = "NONE",
    DAMAGE = "DAMAGE",
    ESTIMATION = "ESTIMATION",
    SUBSIDY = "SUBSIDY",
}

export enum CreateMessageDtoQuestionType {
    MY_ACCOUNT = "MY_ACCOUNT",
    GENERAL_QUESTION = "GENERAL_QUESTION",
    CLAIM = "CLAIM",
    PREVENTION = "PREVENTION",
    ESTIMATION = "ESTIMATION",
    BUILDINGS = "BUILDINGS",
    SINISTRE = "SINISTRE",
    SUBSIDIES = "SUBSIDIES",
}

export enum MyEcabTownGroupDtoType {
    ESTIMATION = "ESTIMATION",
    INCIDENT = "INCIDENT",
    EXPERT_INCIDENT = "EXPERT_INCIDENT",
}

export enum StatusList {
    OPEN = "OPEN",
    HANDLED = "HANDLED",
}

export enum MyEcabPersonAddressDtoType {
    RESIDENTIAL = "RESIDENTIAL",
    INVOICING = "INVOICING",
    CORRESPONDANCE = "CORRESPONDANCE",
}

export enum MyEcabPersonCommunicationDtoCategory {
    TELEPHONE = "TELEPHONE",
    MOBILE = "MOBILE",
    MAIL = "MAIL",
}

export enum MyEcabPersonCommunicationDtoType {
    PRIVATE = "PRIVATE",
    BUSINESS = "BUSINESS",
}

export enum MyEcabPersonDtoType {
    PHYSICAL = "PHYSICAL",
    MORAL = "MORAL",
}

export enum MyEcabPersonDtoTitle {
    MR = "MR",
    MS = "MS",
}

export enum FilterSelectionDtoMode {
    ALL = "ALL",
    EMPTY = "EMPTY",
    SELECTED_VALUES = "SELECTED_VALUES",
}

export enum MessageFilterCriteriaDtoCaseType {
    NONE = "NONE",
    DAMAGE = "DAMAGE",
    ESTIMATION = "ESTIMATION",
    SUBSIDY = "SUBSIDY",
}

export enum MessageFilterCriteriaDtoQuestionType {
    MY_ACCOUNT = "MY_ACCOUNT",
    GENERAL_QUESTION = "GENERAL_QUESTION",
    CLAIM = "CLAIM",
    PREVENTION = "PREVENTION",
    ESTIMATION = "ESTIMATION",
    BUILDINGS = "BUILDINGS",
    SINISTRE = "SINISTRE",
    SUBSIDIES = "SUBSIDIES",
}

export enum PredefinedMessageFilterDtoTargetView {
    MESSAGES = "MESSAGES",
    OPEN_MESSAGES = "OPEN_MESSAGES",
}

export enum MyEcabBuildingSummaryDtoBuildingState {
    TRANSITIONAL = "TRANSITIONAL",
    UNDER_CONSTRUCTION = "UNDER_CONSTRUCTION",
    IN_USE = "IN_USE",
    DEMOLISHED = "DEMOLISHED",
}

export enum MyEcabIncidentSummaryDtoWorkflowState {
    DATA_INPUT = "DATA_INPUT",
    PRINT_INCIDENT_STATEMENT = "PRINT_INCIDENT_STATEMENT",
    OPENING_RESERVE_FUNDS = "OPENING_RESERVE_FUNDS",
    TRANSMIT_REQUEST = "TRANSMIT_REQUEST",
    ASSIGN_INCIDENT = "ASSIGN_INCIDENT",
    INPUT_ASSESSMENT = "INPUT_ASSESSMENT",
    RESERVE_FUNDS_FOR_LVP = "RESERVE_FUNDS_FOR_LVP",
    INPUT_DAMAGE_ESTIMATION = "INPUT_DAMAGE_ESTIMATION",
    REVIEW_ESTIMATION = "REVIEW_ESTIMATION",
    SIGN_ESTIMATION = "SIGN_ESTIMATION",
    TRANSMIT_ESTIMATION_TO_INCIDENT_SERVICE = "TRANSMIT_ESTIMATION_TO_INCIDENT_SERVICE",
    REVIEW_BY_INCIDENT_SERVICE = "REVIEW_BY_INCIDENT_SERVICE",
    INCIDENT_SERVICE_TRIFLE = "INCIDENT_SERVICE_TRIFLE",
    REVIEW_BY_HEAD_OF_INCIDENT = "REVIEW_BY_HEAD_OF_INCIDENT",
    REVIEW_BY_HEAD_OF_INSURANCE = "REVIEW_BY_HEAD_OF_INSURANCE",
    DECISION_BY_ECAB = "DECISION_BY_ECAB",
    PRINT_DAMAGE_PROTOCOL = "PRINT_DAMAGE_PROTOCOL",
    PRINT_QUOTATIONS = "PRINT_QUOTATIONS",
    VALIDATE_PAYMENTS = "VALIDATE_PAYMENTS",
    VALIDATE_FINAL_PAYMENTS = "VALIDATE_FINAL_PAYMENTS",
    CLOSED = "CLOSED",
}

export enum MyEcabIncidentSummaryDtoStatus {
    ANNOUNCED = "ANNOUNCED",
    RUNNING = "RUNNING",
    CLOSED = "CLOSED",
    PRESCRIBED = "PRESCRIBED",
    COMPLAINT = "COMPLAINT",
    COMPLEMENT = "COMPLEMENT",
}

export enum MyEcabInsuranceContractDtoType {
    INDIVIDUAL = "INDIVIDUAL",
    PART_OWNER = "PART_OWNER",
    JOINT_OWNER = "JOINT_OWNER",
    PPE = "PPE",
    HEIR = "HEIR",
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}